const AddressData = [
  {
    district: "Aveiro",
    code: 1,
    county: [
      {
        countyName: "Águeda",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Aguada De Cima",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Fermentelos",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Macinhata Do Vouga",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Valongo Do Vouga",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Águeda E Borralha",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Barrô E Aguada De Baixo",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Belazaima Do Chão, Castanheira Do Vouga E Agadão",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Recardães E Espinhel",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Travassô E Óis Da Ribeira",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Trofa, Segadães E Lamas Do Vouga",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias Do Préstimo E Macieira De Alcoba",
            freguesiaCode: "27",
          },
        ],
      },
      {
        countyName: "Albergaria-A-Velha",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Alquerubim",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Angeja",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Branca",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ribeira De Fráguas",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Albergaria-A-Velha E Valmaior",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São João De Loure E Frossos",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Anadia",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Avelãs De Caminho",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Avelãs De Cima",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Moita",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Sangalhos",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Lourenço Do Bairro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vila Nova De Monsarros",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Vilarinho Do Bairro",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Amoreira Da Gândara, Paredes Do Bairro E Ancas",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Arcos E Mogofores",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tamengos, Aguim E Óis Do Bairro",
            freguesiaCode: "18",
          },
        ],
      },
      {
        countyName: "Arouca",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Alvarenga",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Chave",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Escariz",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Fermedo",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Mansores",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Moldes",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Rossas",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Santa Eulália",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "São Miguel Do Mato",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Tropeço",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Urrô",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Várzea",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Arouca E Burgo",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cabreiros E Albergaria Da Serra",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Canelas E Espiunca",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Covelo De Paivó E Janarde",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Aveiro",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Aradas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cacia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Esgueira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Oliveirinha",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "São Bernardo",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "São Jacinto",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Santa Joana",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Eixo E Eirol",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Requeixo, Nossa Senhora De Fátima E Nariz",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Glória E Vera Cruz",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Castelo De Paiva",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Fornos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Real",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Santa Maria De Sardoura",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São Martinho De Sardoura",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Raiva, Pedorido E Paraíso",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Sobrado E Bairros",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Espinho",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Espinho",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Paramos",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Silvalde",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Anta E Guetim",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Estarreja",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Avanca",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Pardilhó",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Salreu",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Beduído E Veiros",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Canelas E Fermelã",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Santa Maria Da Feira",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Argoncilhe",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arrifana",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Escapães",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Fiães",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Fornos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Lourosa",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Milheirós De Poiares",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Mozelos",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Nogueira Da Regedoura",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "São Paio De Oleiros",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Paços De Brandão",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Rio Meão",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Romariz",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Sanguedo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Santa Maria De Lamas",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "São João De Ver",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caldas De São Jorge E Pigeiros",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "União Das Freguesias De Canedo, Vale E Vila Maior",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lobão, Gião, Louredo E Guisande",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Maria Da Feira, Travanca, Sanfins E Espargo",
            freguesiaCode: "35",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Miguel Do Souto E Mosteirô",
            freguesiaCode: "36",
          },
        ],
      },
      {
        countyName: "Ílhavo",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Gafanha Da Encarnação",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Gafanha Da Nazaré",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Gafanha Do Carmo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Ílhavo (São Salvador)",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Mealhada",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Barcouço",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Casal Comba",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Luso",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Pampilhosa",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Vacariça",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias Da Mealhada, Ventosa Do Bairro E Antes",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Murtosa",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Bunheiro",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Monte",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Murtosa",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Torreira",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Oliveira De Azeméis",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Carregosa",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cesar",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fajões",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Loureiro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Macieira De Sarnes",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ossela",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "São Martinho Da Gândara",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "São Roque",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vila De Cucujães",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Nogueira Do Cravo E Pindelo",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oliveira De Azeméis, Santiago Da Riba-Ul, Ul, Macinhata Da Seixa E Madail",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pinheiro Da Bemposta, Travanca E Palmaz",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Oliveira Do Bairro",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Oiã",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Oliveira Do Bairro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Palhaça",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bustos, Troviscal E Mamarrosa",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Ovar",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Cortegaça",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Esmoriz",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Maceda",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Válega",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ovar, São João, Arada E São Vicente De Pereira Jusã",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "São João Da Madeira",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "São João Da Madeira",
            freguesiaCode: "01",
          },
        ],
      },
      {
        countyName: "Sever Do Vouga",
        countyCode: "17",
        fregusias: [
          {
            freguesiaName: "Couto De Esteves",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pessegueiro Do Vouga",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Rocas Do Vouga",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Sever Do Vouga",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Talhadas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Cedrim E Paradela",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Silva Escura E Dornelas",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Vagos",
        countyCode: "18",
        fregusias: [
          {
            freguesiaName: "Calvão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Gafanha Da Boa Hora",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ouca",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Sosa",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Santo André De Vagos",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Fonte De Angeão E Covão Do Lobo",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ponte De Vagos E Santa Catarina",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Vagos E Santo António",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Vale De Cambra",
        countyCode: "19",
        fregusias: [
          {
            freguesiaName: "Arões",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "São Pedro De Castelões",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cepelos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Junqueira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Macieira De Cambra",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Roge",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Chã, Codal E Vila Cova De Perrinho",
            freguesiaCode: "10",
          },
        ],
      },
    ],
  },
  {
    district: "Beja",
    code: 2,
    county: [
      {
        countyName: "Aljustrel",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Ervidel",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Messejana",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São João De Negrilhos",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "União Das Freguesias De Aljustrel E Rio De Moinhos",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Almodôvar",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Rosário",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santa Cruz",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São Barnabé",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Aldeia Dos Fernandes",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Almodôvar E Graça Dos Padrões",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Clara-A-Nova E Gomes Aires",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Alvito",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Alvito",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Vila Nova Da Baronia",
            freguesiaCode: "02",
          },
        ],
      },
      {
        countyName: "Barrancos",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Barrancos",
            freguesiaCode: "01",
          },
        ],
      },
      {
        countyName: "Beja",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Baleizão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Beringel",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cabeça Gorda",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Nossa Senhora Das Neves",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Santa Clara De Louredo",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "São Matias",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Albernoa E Trindade",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Beja (Salvador E Santa Maria Da Feira)",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Beja (Santiago Maior E São João Baptista)",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Salvada E Quintos",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Santa Vitória E Mombeja",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Trigaches E São Brissos",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Castro Verde",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Entradas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santa Bárbara De Padrões",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Marcos Da Ataboeira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Castro Verde E Casével",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Cuba",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Cuba",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Faro Do Alentejo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vila Alva",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Ruiva",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Ferreira Do Alentejo",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Figueira Dos Cavaleiros",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Odivelas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "União Das Freguesias De Alfundão E Peroguarda",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ferreira Do Alentejo E Canhestros",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Mértola",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Alcaria Ruiva",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Corte Do Pinto",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Espírito Santo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Mértola",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santana De Cambas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São João Dos Caldeireiros",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Miguel Do Pinheiro, São Pedro De Solis E São Sebastião Dos Carros",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Moura",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Amareleja",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Póvoa De São Miguel",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sobral Da Adiça",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Moura (Santo Agostinho E São João Baptista) E Santo Amador",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Safara E Santo Aleixo Da Restauração",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Odemira",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Relíquias",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sabóia",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Luís",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "São Martinho Das Amoreiras",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Vila Nova De Milfontes",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Luzianes-Gare",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Boavista Dos Pinheiros",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Longueira/Almograve",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Colos",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Santa Clara-A-Velha",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "São Salvador E Santa Maria",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "São Teotónio",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Vale De Santiago",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Ourique",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Ourique",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santana Da Serra",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Garvão E Santa Luzia",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Panoias E Conceição",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Serpa",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Brinches",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pias",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Verde De Ficalho",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Serpa (Salvador E Santa Maria)",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Nova De São Bento E Vale De Vargo",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Vidigueira",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Pedrógão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Selmes",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vidigueira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila De Frades",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Braga",
    code: 3,
    county: [
      {
        countyName: "Amares",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Barreiros",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bico",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Caires",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Carrazedo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Dornelas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Fiscal",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Goães",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Lago",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Rendufe",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Bouro (Santa Maria)",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Bouro (Santa Marta)",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Amares E Figueiredo",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caldelas, Sequeiros E Paranhos",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ferreiros, Prozelo E Besteiros",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Torre E Portela",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilela, Seramil E Paredes Secas",
            freguesiaCode: "29",
          },
        ],
      },
      {
        countyName: "Barcelos",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Abade De Neiva",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Aborim",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Adães",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Airó",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Aldreu",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Alvelos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Arcozelo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Areias",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Balugães",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Barcelinhos",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Barqueiros",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Cambeses",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Carapeços",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Carvalhal",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Carvalhas",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Cossourado",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Cristelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Fornelos",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Fragoso",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Gilmonde",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Lama",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Lijó",
            freguesiaCode: "43",
          },
          {
            freguesiaName: "Macieira De Rates",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Manhente",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "Martim",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Moure",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "Oliveira",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Palme",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "Panque",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "Paradela",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "Pereira",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "Perelhal",
            freguesiaCode: "60",
          },
          {
            freguesiaName: "Pousa",
            freguesiaCode: "61",
          },
          {
            freguesiaName: "Remelhe",
            freguesiaCode: "63",
          },
          {
            freguesiaName: "Roriz",
            freguesiaCode: "64",
          },
          {
            freguesiaName: "Rio Covo (Santa Eugénia)",
            freguesiaCode: "65",
          },
          {
            freguesiaName: "Galegos (Santa Maria)",
            freguesiaCode: "68",
          },
          {
            freguesiaName: "Galegos (São Martinho)",
            freguesiaCode: "72",
          },
          {
            freguesiaName: "Tamel (São Veríssimo)",
            freguesiaCode: "77",
          },
          {
            freguesiaName: "Silva",
            freguesiaCode: "79",
          },
          {
            freguesiaName: "Ucha",
            freguesiaCode: "82",
          },
          {
            freguesiaName: "Várzea",
            freguesiaCode: "83",
          },
          {
            freguesiaName: "Vila Seca",
            freguesiaCode: "87",
          },
          {
            freguesiaName: "União Das Freguesias De Alheira E Igreja Nova",
            freguesiaCode: "90",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alvito (São Pedro E São Martinho) E Couto",
            freguesiaCode: "91",
          },
          {
            freguesiaName:
              "União Das Freguesias De Areias De Vilar E Encourados",
            freguesiaCode: "92",
          },
          {
            freguesiaName:
              "União Das Freguesias De Barcelos, Vila Boa E Vila Frescainha (São Martinho E São Pedro)",
            freguesiaCode: "93",
          },
          {
            freguesiaName:
              "União Das Freguesias De Campo E Tamel (São Pedro Fins)",
            freguesiaCode: "94",
          },
          {
            freguesiaName: "União Das Freguesias De Carreira E Fonte Coberta",
            freguesiaCode: "95",
          },
          {
            freguesiaName:
              "União Das Freguesias De Chorente, Góios, Courel, Pedra Furada E Gueral",
            freguesiaCode: "96",
          },
          {
            freguesiaName: "União Das Freguesias De Creixomil E Mariz",
            freguesiaCode: "97",
          },
          {
            freguesiaName: "União Das Freguesias De Durrães E Tregosa",
            freguesiaCode: "98",
          },
          {
            freguesiaName: "União Das Freguesias De Gamil E Midões",
            freguesiaCode: "99",
          },
          {
            freguesiaName:
              "União Das Freguesias De Milhazes, Vilar De Figos E Faria",
            freguesiaCode: "FA",
          },
          {
            freguesiaName: "União Das Freguesias De Negreiros E Chavão",
            freguesiaCode: "FB",
          },
          {
            freguesiaName: "União Das Freguesias De Quintiães E Aguiar",
            freguesiaCode: "FC",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sequeade E Bastuço (São João E Santo Estevão)",
            freguesiaCode: "FD",
          },
          {
            freguesiaName:
              "União Das Freguesias De Silveiros E Rio Covo (Santa Eulália)",
            freguesiaCode: "FE",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tamel (Santa Leocádia) E Vilar Do Monte",
            freguesiaCode: "FF",
          },
          {
            freguesiaName:
              "União Das Freguesias De Viatodos, Grimancelos, Minhotães E Monte De Fralães",
            freguesiaCode: "FG",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Cova E Feitos",
            freguesiaCode: "FH",
          },
        ],
      },
      {
        countyName: "Braga",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Adaúfe",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Espinho",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Esporões",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Figueiredo",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Gualtar",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Lamas",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Mire De Tibães",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Padim Da Graça",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Palmeira",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Pedralva",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Priscos",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Ruilhe",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Braga (São Vicente)",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "Braga (São Vítor)",
            freguesiaCode: "51",
          },
          {
            freguesiaName: "Sequeira",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Sobreposta",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "Tadim",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "Tebosa",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "União Das Freguesias De Arentim E Cunha",
            freguesiaCode: "63",
          },
          {
            freguesiaName:
              "União Das Freguesias De Braga (Maximinos, Sé E Cividade)",
            freguesiaCode: "64",
          },
          {
            freguesiaName:
              "União Das Freguesias De Braga (São José De São Lázaro E São João Do Souto)",
            freguesiaCode: "65",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cabreiros E Passos (São Julião)",
            freguesiaCode: "66",
          },
          {
            freguesiaName:
              "União Das Freguesias De Celeirós, Aveleda E Vimieiro",
            freguesiaCode: "67",
          },
          {
            freguesiaName: "União Das Freguesias De Crespos E Pousada",
            freguesiaCode: "68",
          },
          {
            freguesiaName:
              "União Das Freguesias De Escudeiros E Penso (Santo Estêvão E São Vicente)",
            freguesiaCode: "69",
          },
          {
            freguesiaName:
              "União Das Freguesias De Este (São Pedro E São Mamede)",
            freguesiaCode: "70",
          },
          {
            freguesiaName: "União Das Freguesias De Ferreiros E Gondizalves",
            freguesiaCode: "71",
          },
          {
            freguesiaName:
              "União Das Freguesias De Guisande E Oliveira (São Pedro)",
            freguesiaCode: "72",
          },
          {
            freguesiaName: "União Das Freguesias De Lomar E Arcos",
            freguesiaCode: "73",
          },
          {
            freguesiaName:
              "União Das Freguesias De Merelim (São Paio), Panoias E Parada De Tibães",
            freguesiaCode: "74",
          },
          {
            freguesiaName:
              "União Das Freguesias De Merelim (São Pedro) E Frossos",
            freguesiaCode: "75",
          },
          {
            freguesiaName: "União Das Freguesias De Morreira E Trandeiras",
            freguesiaCode: "76",
          },
          {
            freguesiaName:
              "União Das Freguesias De Nogueira, Fraião E Lamaçães",
            freguesiaCode: "77",
          },
          {
            freguesiaName: "União Das Freguesias De Nogueiró E Tenões",
            freguesiaCode: "78",
          },
          {
            freguesiaName: "União Das Freguesias De Real, Dume E Semelhe",
            freguesiaCode: "79",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Lucrécia De Algeriz E Navarra",
            freguesiaCode: "80",
          },
          {
            freguesiaName: "União Das Freguesias De Vilaça E Fradelos",
            freguesiaCode: "81",
          },
        ],
      },
      {
        countyName: "Cabeceiras De Basto",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Abadim",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Basto",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Bucos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cabeceiras De Basto",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Cavez",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Faia",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pedraça",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Rio Douro",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Alvite E Passos",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Arco De Baúlhe E Vila Nune",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Gondiães E Vilar De Cunhas",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Refojos De Basto, Outeiro E Painzela",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Celorico De Basto",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Agilde",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arnóia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Borba De Montanha",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Codeçoso",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Fervença",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Moreira Do Castelo",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Rego",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Ribas",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Basto (São Clemente)",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Vale De Bouro",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Britelo, Gémeos E Ourilhe",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Caçarilhe E Infesta",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Canedo De Basto E Corgo",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Carvalho E Basto (Santa Tecla)",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Veade, Gagos E Molares",
            freguesiaCode: "27",
          },
        ],
      },
      {
        countyName: "Esposende",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Antas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Forjães",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Gemeses",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vila Chã",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Apúlia E Fão",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Belinho E Mar",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Esposende, Marinhas E Gandra",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Fonte Boa E Rio Tinto",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Palmeira De Faro E Curvos",
            freguesiaCode: "20",
          },
        ],
      },
      {
        countyName: "Fafe",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Armil",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Estorãos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Fafe",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Fornelos",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Golães",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Medelo",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Passos",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Quinchães",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Regadas",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Revelhe",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Ribeiros",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Arões (Santa Cristina)",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "São Gens",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Silvares (São Martinho)",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Arões (São Romão)",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Travassós",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Vinhós",
            freguesiaCode: "36",
          },
          {
            freguesiaName:
              "União De Freguesias De Aboim, Felgueiras, Gontim E Pedraído",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União De Freguesias De Agrela E Serafão",
            freguesiaCode: "38",
          },
          {
            freguesiaName:
              "União De Freguesias De Antime E Silvares (São Clemente)",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União De Freguesias De Ardegão, Arnozela E Seidões",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União De Freguesias De Cepães E Fareja",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "União De Freguesias De Freitas E Vila Cova",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "União De Freguesias De Monte E Queimadela",
            freguesiaCode: "43",
          },
          {
            freguesiaName:
              "União De Freguesias De Moreira Do Rei E Várzea Cova",
            freguesiaCode: "44",
          },
        ],
      },
      {
        countyName: "Guimarães",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Aldão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Azurém",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Barco",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Brito",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Caldelas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Costa",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Creixomil",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Fermentões",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Gonça",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Gondar",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Guardizela",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Infantas",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Longos",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Lordelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Mesão Frio",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Moreira De Cónegos",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Nespereira",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Pencelo",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Polvoreira",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Ponte",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Ronfe",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Prazins (Santa Eufémia)",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Selho (São Cristóvão)",
            freguesiaCode: "50",
          },
          {
            freguesiaName: "Selho (São Jorge)",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Candoso (São Martinho)",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "Sande (São Martinho)",
            freguesiaCode: "58",
          },
          {
            freguesiaName: "São Torcato",
            freguesiaCode: "65",
          },
          {
            freguesiaName: "Serzedelo",
            freguesiaCode: "66",
          },
          {
            freguesiaName: "Silvares",
            freguesiaCode: "68",
          },
          {
            freguesiaName: "Urgezes",
            freguesiaCode: "71",
          },
          {
            freguesiaName: "União Das Freguesias De Abação E Gémeos",
            freguesiaCode: "75",
          },
          {
            freguesiaName:
              "União Das Freguesias De Airão Santa Maria, Airão São João E Vermil",
            freguesiaCode: "76",
          },
          {
            freguesiaName: "União Das Freguesias De Arosa E Castelões",
            freguesiaCode: "77",
          },
          {
            freguesiaName: "União Das Freguesias De Atães E Rendufe",
            freguesiaCode: "78",
          },
          {
            freguesiaName:
              "União Das Freguesias De Briteiros Santo Estêvão E Donim",
            freguesiaCode: "79",
          },
          {
            freguesiaName:
              "União Das Freguesias De Briteiros São Salvador E Briteiros Santa Leocádia",
            freguesiaCode: "80",
          },
          {
            freguesiaName:
              "União Das Freguesias De Candoso São Tiago E Mascotelos",
            freguesiaCode: "81",
          },
          {
            freguesiaName: "União Das Freguesias De Conde E Gandarela",
            freguesiaCode: "82",
          },
          {
            freguesiaName:
              "União Das Freguesias De Leitões, Oleiros E Figueiredo",
            freguesiaCode: "83",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oliveira, São Paio E São Sebastião",
            freguesiaCode: "84",
          },
          {
            freguesiaName:
              "União Das Freguesias De Prazins Santo Tirso E Corvite",
            freguesiaCode: "85",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sande São Lourenço E Balazar",
            freguesiaCode: "86",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sande Vila Nova E Sande São Clemente",
            freguesiaCode: "87",
          },
          {
            freguesiaName:
              "União Das Freguesias De Selho São Lourenço E Gominhães",
            freguesiaCode: "88",
          },
          {
            freguesiaName: "União Das Freguesias De Serzedo E Calvos",
            freguesiaCode: "89",
          },
          {
            freguesiaName:
              "União Das Freguesias De Souto Santa Maria, Souto São Salvador E Gondomar",
            freguesiaCode: "90",
          },
          {
            freguesiaName: "União Das Freguesias De Tabuadelo E São Faustino",
            freguesiaCode: "91",
          },
        ],
      },
      {
        countyName: "Póvoa De Lanhoso",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Covelas",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ferreiros",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Galegos",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Garfe",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Geraz Do Minho",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Lanhoso",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Monsul",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Póvoa De Lanhoso (Nossa Senhora Do Amparo)",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Rendufinho",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Santo Emilião",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "São João De Rei",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Serzedelo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Sobradelo Da Goma",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Taíde",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Travassos",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Vilela",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "União Das Freguesias De Águas Santas E Moure",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Calvos E Frades",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Campos E Louredo",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "União Das Freguesias De Esperança E Brunhais",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Fonte Arcada E Oliveira",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Verim, Friande E Ajude",
            freguesiaCode: "35",
          },
        ],
      },
      {
        countyName: "Terras De Bouro",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Balança",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Campo Do Gerês",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carvalheira",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Covide",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Gondoriz",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Moimenta",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ribeira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Rio Caldo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Souto",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Valdosende",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Vilar Da Veiga",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Chamoim E Vilar",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Chorense E Monte",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Cibões E Brufe",
            freguesiaCode: "20",
          },
        ],
      },
      {
        countyName: "Vieira Do Minho",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Cantelães",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Eira Vedra",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Guilhofrei",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Louredo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Mosteiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Parada Do Bouro",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Rossas",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Salamonde",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Tabuaças",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vieira Do Minho",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Anissó E Soutelo",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Anjos E Vilar Do Chão",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Caniçada E Soengas",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Ruivães E Campos",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Ventosa E Cova",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Vila Nova De Famalicão",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Bairro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Brufe",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Castelões",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Cruz",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Delães",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Fradelos",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Gavião",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Joane",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Landim",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Louro",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Lousado",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Mogege",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Nine",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Pedome",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Pousada De Saramagos",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Requião",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Riba De Ave",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Ribeirão",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Oliveira (Santa Maria)",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Vale (São Martinho)",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "Oliveira (São Mateus)",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Vermoim",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Vilarinho Das Cambas",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "União Das Freguesias De Antas E Abade De Vermoim",
            freguesiaCode: "50",
          },
          {
            freguesiaName:
              "União Das Freguesias De Arnoso (Santa Maria E Santa Eulália) E Sezures",
            freguesiaCode: "51",
          },
          {
            freguesiaName: "União Das Freguesias De Avidos E Lagoa",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "União Das Freguesias De Carreira E Bente",
            freguesiaCode: "53",
          },
          {
            freguesiaName: "União Das Freguesias De Esmeriz E Cabeçudos",
            freguesiaCode: "54",
          },
          {
            freguesiaName:
              "União Das Freguesias De Gondifelos, Cavalões E Outiz",
            freguesiaCode: "55",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lemenhe, Mouquim E Jesufrei",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "União Das Freguesias De Ruivães E Novais",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "União Das Freguesias De Seide",
            freguesiaCode: "58",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale (São Cosme), Telhado E Portela",
            freguesiaCode: "59",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Nova De Famalicão E Calendário",
            freguesiaCode: "60",
          },
        ],
      },
      {
        countyName: "Vila Verde",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Atiães",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cabanelas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Cervães",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Coucieiro",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Dossãos",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Freiriz",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Gême",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Lage",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Lanhas",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Loureira",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Moure",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Oleiros",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Parada De Gatim",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Pico",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Ponte",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Sabariz",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Vila De Prado",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Prado (São Miguel)",
            freguesiaCode: "50",
          },
          {
            freguesiaName: "Soutelo",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "Turiz",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Valdreu",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "Aboim Da Nóbrega E Gondomar",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "União Das Freguesias Da Ribeira Do Neiva",
            freguesiaCode: "60",
          },
          {
            freguesiaName:
              "União Das Freguesias De Carreiras (São Miguel) E Carreiras (Santiago)",
            freguesiaCode: "61",
          },
          {
            freguesiaName:
              "União Das Freguesias De Escariz (São Mamede) E Escariz (São Martinho)",
            freguesiaCode: "62",
          },
          {
            freguesiaName:
              "União Das Freguesias De Esqueiros, Nevogilde E Travassós",
            freguesiaCode: "63",
          },
          {
            freguesiaName: "União Das Freguesias De Marrancos E Arcozelo",
            freguesiaCode: "64",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oriz (Santa Marinha) E Oriz (São Miguel)",
            freguesiaCode: "65",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pico De Regalados, Gondiães E Mós",
            freguesiaCode: "66",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sande, Vilarinho, Barros E Gomide",
            freguesiaCode: "67",
          },
          {
            freguesiaName:
              "União Das Freguesias De Valbom (São Pedro), Passô E Valbom (São Martinho)",
            freguesiaCode: "68",
          },
          {
            freguesiaName: "União Das Freguesias Do Vade",
            freguesiaCode: "69",
          },
          {
            freguesiaName: "Vila Verde E Barbudo",
            freguesiaCode: "70",
          },
        ],
      },
      {
        countyName: "Vizela",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Santa Eulália",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Infias",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vizela (Santo Adrião)",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caldas De Vizela (São Miguel E São João)",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tagilde E Vizela (São Paio)",
            freguesiaCode: "09",
          },
        ],
      },
    ],
  },
  {
    district: "Bragança",
    code: 4,
    county: [
      {
        countyName: "Alfândega Da Fé",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Alfândega Da Fé",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cerejais",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Sambade",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Vilar Chão",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vilarelhos",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Vilares De Vilariça",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Agrobom, Saldonha E Vale Pereiro",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Eucisia, Gouveia E Valverde",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ferradosa E Sendim Da Serra",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Gebelim E Soeima",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Parada E Sendim Da Ribeira",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Pombal E Vales",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Bragança",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Alfaião",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Babe",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Baçal",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Carragosa",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Castro De Avelãs",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Coelhoso",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Donai",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Espinhosela",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "França",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Gimonde",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Gondesende",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Gostei",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Grijó De Parada",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Macedo Do Mato",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Mós",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Nogueira",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Outeiro",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Parâmio",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Pinela",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Quintanilha",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Quintela De Lampaças",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Rabal",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Rebordãos",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Salsas",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Samil",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Santa Comba De Rossas",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "São Pedro De Sarracenos",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Sendas",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "Serapicos",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Sortes",
            freguesiaCode: "48",
          },
          {
            freguesiaName: "Zoio",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "União Das Freguesias De Aveleda E Rio De Onor",
            freguesiaCode: "50",
          },
          {
            freguesiaName: "União Das Freguesias De Castrelos E Carrazedo",
            freguesiaCode: "51",
          },
          {
            freguesiaName:
              "União Das Freguesias De Izeda, Calvelhe E Paradinha Nova",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "União Das Freguesias De Parada E Faílde",
            freguesiaCode: "53",
          },
          {
            freguesiaName: "União Das Freguesias De Rebordainhos E Pombares",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "União Das Freguesias De Rio Frio E Milhão",
            freguesiaCode: "55",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Julião De Palácios E Deilão",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "União Das Freguesias De Sé, Santa Maria E Meixedo",
            freguesiaCode: "57",
          },
        ],
      },
      {
        countyName: "Carrazeda De Ansiães",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Carrazeda De Ansiães",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Fonte Longa",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Linhares",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Marzagão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Parambos",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Pereiros",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Pinhal Do Norte",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Pombal",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Seixo De Ansiães",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Vilarinho Da Castanheira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Amedo E Zedes",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Belver E Mogo De Malta",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Castanheiro Do Norte E Ribalonga",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lavandeira, Beira Grande E Selores",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Freixo De Espada À Cinta",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Ligares",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Poiares",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Freixo De Espada À Cinta E Mazouco",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Lagoaça E Fornos",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Macedo De Cavaleiros",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Amendoeira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Arcas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carrapatas",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Chacim",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Cortiços",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Corujas",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ferreira",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Grijó",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Lagoa",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Lamalonga",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Lamas",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Lombo",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Macedo De Cavaleiros",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Morais",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Olmos",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Peredo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Salselas",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Sezulfe",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Talhas",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Vale Benfeito",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Vale Da Porca",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Vale De Prados",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Vilarinho De Agrochão",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Vinhas",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Ala E Vilarinho Do Monte",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União Das Freguesias De Bornes E Burga",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União Das Freguesias De Castelãos E Vilar Do Monte",
            freguesiaCode: "41",
          },
          {
            freguesiaName:
              "União Das Freguesias De Espadanedo, Edroso, Murçós E Soutelo Mourisco",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "União Das Freguesias De Podence E Santa Combinha",
            freguesiaCode: "43",
          },
          {
            freguesiaName: "União Das Freguesias De Talhinhas E Bagueixe",
            freguesiaCode: "44",
          },
        ],
      },
      {
        countyName: "Miranda Do Douro",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Duas Igrejas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Genísio",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Malhadas",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Miranda Do Douro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Palaçoulo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Picote",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Póvoa",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "São Martinho De Angueira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vila Chã De Braciosa",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Constantim E Cicouro",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Ifanes E Paradela",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Sendim E Atenor",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Silva E Águas Vivas",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Mirandela",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Abambres",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Abreiro",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aguieiras",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Alvites",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Bouça",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Cabanelas",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Caravelas",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Carvalhais",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Cedães",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Cobro",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Fradizela",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Frechas",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Lamas De Orelhão",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Mascarenhas",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Mirandela",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Múrias",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Passos",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "São Pedro Velho",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "São Salvador",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Suçães",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Torre De Dona Chama",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Vale De Asnes",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Vale De Gouvinhas",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Vale De Salgueiro",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Vale De Telhas",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Avantos E Romeu",
            freguesiaCode: "38",
          },
          {
            freguesiaName:
              "União Das Freguesias De Avidagos, Navalho E Pereira",
            freguesiaCode: "39",
          },
          {
            freguesiaName:
              "União Das Freguesias De Barcel, Marmelos E Valverde Da Gestosa",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União Das Freguesias De Franco E Vila Boa",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "União Das Freguesias De Freixeda E Vila Verde",
            freguesiaCode: "42",
          },
        ],
      },
      {
        countyName: "Mogadouro",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Azinhoso",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Bemposta",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bruçó",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Brunhoso",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Castelo Branco",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Castro Vicente",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Meirinhos",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Paradela",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Penas Roias",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Peredo Da Bemposta",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Saldanha",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "São Martinho Do Peso",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Tó",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Travanca",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Urrós",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Vale Da Madre",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Vila De Ala",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Brunhozinho, Castanheira E Sanhoane",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mogadouro, Valverde, Vale De Porco E Vilar De Rei",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Remondes E Soutelo",
            freguesiaCode: "31",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilarinho Dos Galegos E Ventozelo",
            freguesiaCode: "32",
          },
        ],
      },
      {
        countyName: "Torre De Moncorvo",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Açoreira",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cabeça Boa",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carviçais",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Castedo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Horta Da Vilariça",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Larinho",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Lousa",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Mós",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Torre De Moncorvo",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Adeganha E Cardanha",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Felgar E Souto Da Velha",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Felgueiras E Maçores",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Urros E Peredo Dos Castelhanos",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Vila Flor",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Benlhevai",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Freixiel",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Roios",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Samões",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Sampaio",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Santa Comba De Vilariça",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Seixo De Manhoses",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Trindade",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vale Frechoso",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Assares E Lodões",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Candoso E Carvalho De Egas",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Valtorno E Mourão",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Flor E Nabo",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilas Boas E Vilarinho Das Azenhas",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Vimioso",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Argozelo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carção",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Matela",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pinelo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Santulhão",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vilar Seco",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vimioso",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Algoso, Campo De Víboras E Uva",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Caçarelhos E Angueira",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Vale De Frades E Avelanoso",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Vinhais",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Agrochão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Candedo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Celas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Edral",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Edrosa",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Ervedosa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Paçó",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Penhas Juntas",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Rebordelo",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Santalha",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Tuizelo",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Vale Das Fontes",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Vila Boa De Ousilhão",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Vila Verde",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Vilar De Ossos",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Vilar De Peregrinos",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Vilar Seco De Lomba",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Vinhais",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Curopos E Vale De Janeiro",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Moimenta E Montouto",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União Das Freguesias De Nunes E Ousilhão",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Quirás E Pinheiro Novo",
            freguesiaCode: "39",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sobreiro De Baixo E Alvaredos",
            freguesiaCode: "40",
          },
          {
            freguesiaName:
              "União Das Freguesias De Soeira, Fresulfe E Mofreita",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "União Das Freguesias De Travanca E Santa Cruz",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "União Das Freguesias De Vilar De Lomba E São Jomil",
            freguesiaCode: "43",
          },
        ],
      },
    ],
  },
  {
    district: "Castelo Branco",
    code: 5,
    county: [
      {
        countyName: "Belmonte",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Caria",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Inguias",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Maçainhas",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Belmonte E Colmeal Da Torre",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Castelo Branco",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Alcains",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Almaceda",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Benquerenças",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Castelo Branco",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Lardosa",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Louriçal Do Campo",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Malpica Do Tejo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Monforte Da Beira",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Salgueiro Do Campo",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Santo André Das Tojeiras",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "São Vicente Da Beira",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Sarzedas",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Tinalhas",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Cebolais De Cima E Retaxo",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Escalos De Baixo E Mata",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Escalos De Cima E Lousa",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "União Das Freguesias De Freixial E Juncal Do Campo",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ninho Do Açor E Sobral Do Campo",
            freguesiaCode: "30",
          },
          {
            freguesiaName:
              "União Das Freguesias De Póvoa De Rio De Moinhos E Cafede",
            freguesiaCode: "31",
          },
        ],
      },
      {
        countyName: "Covilhã",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Aldeia De São Francisco De Assis",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Boidobra",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cortes Do Meio",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Dominguizo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Erada",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ferro",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Orjais",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Paul",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Peraboa",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "São Jorge Da Beira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Sobral De São Miguel",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Tortosendo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Unhais Da Serra",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Verdelhos",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Barco E Coutada",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cantar-Galo E Vila Do Carvalho",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Casegas E Ourondo",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Covilhã E Canhoso",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Peso E Vales Do Rio",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Teixoso E Sarzedo",
            freguesiaCode: "37",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale Formoso E Aldeia Do Souto",
            freguesiaCode: "38",
          },
        ],
      },
      {
        countyName: "Fundão",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Alcaide",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alcaria",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Alcongosta",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Alpedrinha",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Barroca",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Bogas De Cima",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Capinha",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Castelejo",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Castelo Novo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Fatela",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Lavacolhos",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Orca",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Pêro Viseu",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Silvares",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Soalheira",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Souto Da Casa",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Telhado",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Enxames",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Três Povos",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Janeiro De Cima E Bogas De Baixo",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Fundão, Valverde, Donas, Aldeia De Joanes E Aldeia Nova Do Cabo",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Póvoa De Atalaia E Atalaia Do Campo",
            freguesiaCode: "35",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale De Prazeres E Mata Da Rainha",
            freguesiaCode: "36",
          },
        ],
      },
      {
        countyName: "Idanha-A-Nova",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Aldeia De Santa Margarida",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ladoeiro",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Medelim",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Oledo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Penha Garcia",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Proença-A-Velha",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Rosmaninhal",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "São Miguel De Acha",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Toulões",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Idanha-A-Nova E Alcafozes",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Monfortinho E Salvaterra Do Extremo",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Monsanto E Idanha-A-Velha",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Zebreira E Segura",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Oleiros",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Álvaro",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cambas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Isna",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Madeirã",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Mosteiro",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Orvalho",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Sarnadas De São Simão",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Sobral",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Estreito-Vilar Barroco",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Oleiros-Amieira",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Penamacor",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Aranhas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Benquerença",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Meimão",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Meimoa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Penamacor",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Salvador",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Vale Da Senhora Da Póvoa",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aldeia Do Bispo, Águas E Aldeia De João Pires",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pedrógão De São Pedro E Bemposta",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Proença-A-Nova",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Montes Da Senhora",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Pedro Do Esteval",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Proença-A-Nova E Peral",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sobreira Formosa E Alvito Da Beira",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Sertã",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Cabeçudo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Carvalhal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Castelo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Pedrógão Pequeno",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Sertã",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Troviscal",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Várzea Dos Cavaleiros",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cernache Do Bonjardim, Nesperal E Palhais",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Cumeada E Marmeleiro",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Ermida E Figueiredo",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Vila De Rei",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Fundada",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "São João Do Peso",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vila De Rei",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Vila Velha De Ródão",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Fratel",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Perais",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sarnadas De Ródão",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Velha De Ródão",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Coimbra",
    code: 6,
    county: [
      {
        countyName: "Arganil",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Arganil",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Benfeita",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Celavisa",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Folques",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Piódão",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Pomares",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Pombeiro Da Beira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Martinho Da Cortiça",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Sarzedo",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Secarias",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Cepos E Teixeira",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Cerdeira E Moura Da Serra",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Côja E Barril De Alva",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Cova De Alva E Anseriz",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Cantanhede",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Ançã",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cadima",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cordinhã",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Febres",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Murtede",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Ourentã",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Tocha",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "São Caetano",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Sanguinheira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Cantanhede E Pocariça",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Covões E Camarneira",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Portunhos E Outil",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Sepins E Bolho",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilamar E Corticeiro De Cima",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Coimbra",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Almalaguês",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Brasfemes",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Ceira",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Cernache",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Santo António Dos Olivais",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "São João Do Campo",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "São Silvestre",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Torres Do Mondego",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "União Das Freguesias De Antuzede E Vil De Matos",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "União Das Freguesias De Assafarge E Antanhol",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Coimbra (Sé Nova, Santa Cruz, Almedina E São Bartolomeu)",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Eiras E São Paulo De Frades",
            freguesiaCode: "35",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Clara E Castelo Viegas",
            freguesiaCode: "36",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Martinho De Árvore E Lamarosa",
            freguesiaCode: "37",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Martinho Do Bispo E Ribeira De Frades",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Souselas E Botão",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União Das Freguesias De Taveiro, Ameal E Arzila",
            freguesiaCode: "40",
          },
          {
            freguesiaName:
              "União Das Freguesias De Trouxemil E Torre De Vilela",
            freguesiaCode: "41",
          },
        ],
      },
      {
        countyName: "Condeixa-A-Nova",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Anobra",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ega",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Furadouro",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Zambujal",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Condeixa-A-Velha E Condeixa-A-Nova",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Sebal E Belide",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Seca E Bem Da Fé",
            freguesiaCode: "13",
          },
        ],
      },
      {
        countyName: "Figueira Da Foz",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Alqueidão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Maiorca",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Marinha Das Ondas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Tavarede",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Vila Verde",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Pedro",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Bom Sucesso",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Moinhos Da Gândara",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Alhadas",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Buarcos",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Ferreira-A-Nova",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Lavos",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Paião",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Quiaios",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Góis",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Alvares",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Góis",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vila Nova Do Ceira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Cadafaz E Colmeal",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Lousã",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Serpins",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Gândaras",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Foz De Arouce E Casal De Ermio",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Lousã E Vilarinho",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Mira",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Mira",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Seixo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carapelhos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Praia De Mira",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Miranda Do Corvo",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Lamas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Miranda Do Corvo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vila Nova",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Semide E Rio Vide",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Montemor-O-Velho",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Arazede",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carapinheira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Liceia",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Meãs Do Campo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Pereira",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Santo Varão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Seixo De Gatões",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Tentúgal",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ereira",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Abrunheira, Verride E Vila Nova Da Barca",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Montemor-O-Velho E Gatões",
            freguesiaCode: "16",
          },
        ],
      },
      {
        countyName: "Oliveira Do Hospital",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Aldeia Das Dez",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alvoco Das Várzeas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Avô",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Bobadela",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Lagares",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Lourosa",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Meruge",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Nogueira Do Cravo",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "São Gião",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Seixo Da Beira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Travanca De Lagos",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ervedal E Vila Franca Da Beira",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Lagos Da Beira E Lajeosa",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oliveira Do Hospital E São Paio De Gramaços",
            freguesiaCode: "24",
          },
          {
            freguesiaName:
              "União Das Freguesias De Penalva De Alva E São Sebastião Da Feira",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Ovaia E Vila Pouca Da Beira",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Pampilhosa Da Serra",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Cabril",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Dornelas Do Zêzere",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Janeiro De Baixo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Pampilhosa Da Serra",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Pessegueiro",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Unhais-O-Velho",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Fajão-Vidual",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Portela Do Fojo-Machio",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Penacova",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Carvalho",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Figueira De Lorvão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Lorvão",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Penacova",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Sazes Do Lorvão",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Friúmes E Paradela",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oliveira Do Mondego E Travanca Do Mondego",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Pedro De Alva E São Paio De Mondego",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Penela",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Cumeeira",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Espinhal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Podentes",
            freguesiaCode: "03",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Miguel, Santa Eufémia E Rabaçal",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Soure",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Alfarelos",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Figueiró Do Campo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Granja Do Ulmeiro",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Samuel",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Soure",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Tapéus",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vila Nova De Anços",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Vinha Da Rainha",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Degracias E Pombalinho",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Gesteira E Brunhós",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Tábua",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Candosa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carapinha",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Midões",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Mouronho",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Póvoa De Midões",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "São João Da Boa Vista",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Tábua",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Ázere E Covelo",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias De Covas E Vila Nova De Oliveirinha",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Espariz E Sinde",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pinheiro De Coja E Meda De Mouros",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Vila Nova De Poiares",
        countyCode: "17",
        fregusias: [
          {
            freguesiaName: "Arrifana",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Lavegadas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Poiares (Santo André)",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Miguel De Poiares",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Évora",
    code: 7,
    county: [
      {
        countyName: "Alandroal",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Santiago Maior",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Capelins (Santo António)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Terena (São Pedro)",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alandroal (Nossa Senhora Da Conceição), São Brás Dos Matos (Mina Do Bugalho) E Juromenha (Nossa Senhora Do Loreto)",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Arraiolos",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Arraiolos",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Igrejinha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vimieiro",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Gafanhoeira (São Pedro) E Sabugueiro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De São Gregório E Santa Justa",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Borba",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Borba (Matriz)",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Orada",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Rio De Moinhos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Borba (São Bartolomeu)",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Estremoz",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Arcos",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Glória",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Évora Monte (Santa Maria)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Domingos De Ana Loura",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Veiros",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Estremoz (Santa Maria E Santo André)",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Bento Do Cortiço E Santo Estêvão",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Lourenço De Mamporcão E São Bento De Ana Loura",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias Do Ameixial (Santa Vitória E São Bento)",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Évora",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Nossa Senhora Da Graça Do Divor",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Nossa Senhora De Machede",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Bento Do Mato",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "São Miguel De Machede",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Torre De Coelheiros",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Canaviais",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Bacelo E Senhora Da Saúde",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Évora (São Mamede, Sé, São Pedro E Santo Antão)",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Malagueira E Horta Das Figueiras",
            freguesiaCode: "24",
          },
          {
            freguesiaName:
              "União Das Freguesias De Nossa Senhora Da Tourega E Nossa Senhora De Guadalupe",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Manços E São Vicente Do Pigeiro",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Sebastião Da Giesteira E Nossa Senhora Da Boa Fé",
            freguesiaCode: "27",
          },
        ],
      },
      {
        countyName: "Montemor-O-Novo",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Cabrela",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santiago Do Escoural",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São Cristóvão",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ciborro",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Foros De Vale De Figueira",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cortiçadas De Lavre E Lavre",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Nossa Senhora Da Vila, Nossa Senhora Do Bispo E Silveiras",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Mora",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Brotas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cabeção",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Mora",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Pavia",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Mourão",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Granja",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Luz",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Mourão",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Portel",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Monte Do Trigo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Portel",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Santana",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Vera Cruz",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Amieira E Alqueva",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Bartolomeu Do Outeiro E Oriola",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Redondo",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Montoito",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Redondo",
            freguesiaCode: "02",
          },
        ],
      },
      {
        countyName: "Reguengos De Monsaraz",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Corval",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Monsaraz",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Reguengos De Monsaraz",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "União Das Freguesias De Campo E Campinho",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Vendas Novas",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Vendas Novas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Landeira",
            freguesiaCode: "02",
          },
        ],
      },
      {
        countyName: "Viana Do Alentejo",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Alcáçovas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Viana Do Alentejo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aguiar",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Vila Viçosa",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Bencatel",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ciladas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pardais",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Nossa Senhora Da Conceição E São Bartolomeu",
            freguesiaCode: "06",
          },
        ],
      },
    ],
  },
  {
    district: "Faro",
    code: 8,
    county: [
      {
        countyName: "Albufeira",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Guia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Paderne",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Ferreiras",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Albufeira E Olhos De Água",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Alcoutim",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Giões",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Martim Longo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vaqueiros",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Alcoutim E Pereiro",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Aljezur",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Aljezur",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Bordeira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Odeceixe",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Rogil",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Castro Marim",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Azinhal",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Castro Marim",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Odeleite",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Altura",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Faro",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Santa Bárbara De Nexe",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Montenegro",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Conceição E Estoi",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Faro (Sé E São Pedro)",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Lagoa",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Ferragudo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Porches",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "União Das Freguesias De Estômbar E Parchal",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Lagoa E Carvoeiro",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Lagos",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Luz",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Odiáxere",
            freguesiaCode: "04",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bensafrim E Barão De São João",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lagos (São Sebastião E Santa Maria)",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Loulé",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Almancil",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alte",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ameixial",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Boliqueime",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Quarteira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Salir",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Loulé (São Clemente)",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Loulé (São Sebastião)",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União De Freguesias De Querença, Tôr E Benafim",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Monchique",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Alferce",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Marmelete",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Monchique",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Olhão",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Olhão",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Pechão",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Quelfes",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Moncarapacho E Fuseta",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Portimão",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Alvor",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Mexilhoeira Grande",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Portimão",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "São Brás De Alportel",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "São Brás De Alportel",
            freguesiaCode: "01",
          },
        ],
      },
      {
        countyName: "Silves",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Armação De Pêra",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Bartolomeu De Messines",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São Marcos Da Serra",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Silves",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Alcantarilha E Pêra",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Algoz E Tunes",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Tavira",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Cachopo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santa Catarina Da Fonte Do Bispo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santa Luzia",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Conceição E Cabanas De Tavira",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Luz De Tavira E Santo Estêvão",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tavira (Santa Maria E Santiago)",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Vila Do Bispo",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Barão De São Miguel",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Budens",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sagres",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vila Do Bispo E Raposeira",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Vila Real De Santo António",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Vila Nova De Cacela",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Vila Real De Santo António",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Monte Gordo",
            freguesiaCode: "03",
          },
        ],
      },
    ],
  },
  {
    district: "Guarda",
    code: 9,
    county: [
      {
        countyName: "Aguiar Da Beira",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Carapito",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cortiçada",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Dornelas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Eirado",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Forninhos",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Pena Verde",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Aguiar Da Beira E Coruche",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Sequeiros E Gradiz",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De Souto De Aguiar Da Beira E Valverde",
            freguesiaCode: "16",
          },
        ],
      },
      {
        countyName: "Almeida",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Almeida",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Castelo Bom",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Freineda",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Freixo",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Malhada Sorda",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Nave De Haver",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "São Pedro De Rio Seco",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Vale Da Mula",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Vilar Formoso",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Amoreira, Parada E Cabreira",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Azinhal, Peva E Valverde",
            freguesiaCode: "31",
          },
          {
            freguesiaName:
              "União Das Freguesias De Castelo Mendo, Ade, Monteperobolso E Mesquitela",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "União Das Freguesias De Junça E Naves",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Leomil, Mido, Senouras E Aldeia Nova",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Malpartida E Vale De Coelha",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Miuzela E Porto De Ovelha",
            freguesiaCode: "36",
          },
        ],
      },
      {
        countyName: "Celorico Da Beira",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Baraçal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carrapichana",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Forno Telheiro",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Lajeosa Do Mondego",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Linhares",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Maçal Do Chão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Mesquitela",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Minhocal",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Prados",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Ratoeira",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vale De Azares",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Casas Do Soeiro",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Açores E Velosa",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Celorico (São Pedro E Santa Maria) E Vila Boa Do Mondego",
            freguesiaCode: "24",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cortiçô Da Serra, Vide Entre Vinhas E Salgueirais",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Rapa E Cadafaz",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Figueira De Castelo Rodrigo",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Castelo Rodrigo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Escalhão",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Figueira De Castelo Rodrigo",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Mata De Lobos",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vermiosa",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De Algodres, Vale De Afonsinho E Vilar De Amargo",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Almofala E Escarigo",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Cinco Vilas E Reigada",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Freixeda Do Torrão, Quintã De Pêro Martins E Penha De Águia",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias Do Colmeal E Vilar Torpim",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Fornos De Algodres",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Algodres",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Casal Vasco",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Figueiró Da Granja",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Fornos De Algodres",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Infias",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Maceira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Matança",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Muxagata",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Queiriz",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Cortiçô E Vila Chã",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Juncais, Vila Ruiva E Vila Soeiro Do Chão",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Sobral Pichorro E Fuinhas",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Gouveia",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Arcozelo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cativelos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Folgosinho",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Nespereira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Paços Da Serra",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Ribamondego",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "São Paio",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vila Cortês Da Serra",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Vila Franca Da Serra",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Vila Nova De Tazem",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aldeias E Mangualde Da Serra",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Figueiró Da Serra E Freixo Da Serra",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Gouveia",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Melo E Nabais",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Moimenta Da Serra E Vinhó",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Rio Torto E Lagarinhos",
            freguesiaCode: "28",
          },
        ],
      },
      {
        countyName: "Guarda",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Aldeia Do Bispo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Aldeia Viçosa",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Alvendre",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Arrifana",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Avelãs Da Ribeira",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Benespera",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Casal De Cinza",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Castanheira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Cavadoude",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Codesseiro",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Faia",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Famalicão",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Fernão Joanes",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Gonçalo Bocas",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "João Antão",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Maçainhas",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Marmeleiro",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Meios",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Panoias De Cima",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Pega",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Pêra Do Moço",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Porto Da Carne",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Ramela",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Santana Da Azinha",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Sobral Da Serra",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Vale De Estrela",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "Valhelhas",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Vela",
            freguesiaCode: "48",
          },
          {
            freguesiaName: "Videmonte",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "Vila Cortês Do Mondego",
            freguesiaCode: "50",
          },
          {
            freguesiaName: "Vila Fernando",
            freguesiaCode: "51",
          },
          {
            freguesiaName: "Vila Franca Do Deão",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "Vila Garcia",
            freguesiaCode: "53",
          },
          {
            freguesiaName: "Gonçalo",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "Guarda",
            freguesiaCode: "58",
          },
          {
            freguesiaName: "Jarmelo São Miguel",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "Jarmelo São Pedro",
            freguesiaCode: "60",
          },
          {
            freguesiaName: "União De Freguesias De Avelãs De Ambom E Rocamondo",
            freguesiaCode: "61",
          },
          {
            freguesiaName: "União De Freguesias De Corujeira E Trinta",
            freguesiaCode: "62",
          },
          {
            freguesiaName:
              "União De Freguesias De Mizarela, Pêro Soares E Vila Soeiro",
            freguesiaCode: "63",
          },
          {
            freguesiaName: "União De Freguesias De Pousade E Albardo",
            freguesiaCode: "64",
          },
          {
            freguesiaName: "União De Freguesias De Rochoso E Monte Margarida",
            freguesiaCode: "65",
          },
          {
            freguesiaName: "Adão",
            freguesiaCode: "66",
          },
        ],
      },
      {
        countyName: "Manteigas",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Sameiro",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Manteigas (Santa Maria)",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Manteigas (São Pedro)",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vale De Amoreira",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Mêda",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Aveloso",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Barreira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Coriscada",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Longroiva",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Marialva",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Poço Do Canto",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Rabaçal",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Ranhados",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Mêda, Outeiro De Gatos E Fonte Longa",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Prova E Casteição",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale Flor, Carvalhal E Pai Penela",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Pinhel",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Ervedosa",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Freixedas",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Lamegal",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Lameiras",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Manigoto",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Pala",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Pinhel",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Pínzio",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Souro Pires",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Vascoveiro",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Agregação Das Freguesias Sul De Pinhel",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Alverca Da Beira/Bouça Cova",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Terras De Massueime",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Valbom/Bogalhal",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Alto Do Palurdo",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Vale Do Côa",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Vale Do Massueime",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Atalaia E Safurdão",
            freguesiaCode: "35",
          },
        ],
      },
      {
        countyName: "Sabugal",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Águas Belas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Aldeia Do Bispo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aldeia Da Ponte",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Aldeia Velha",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Alfaiates",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Baraçal",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Bendada",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Bismula",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Casteleiro",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Cerdeira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Fóios",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Malcata",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Nave",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Quadrazais",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Quintas De São Bartolomeu",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Rapoula Do Côa",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Rebolosa",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Rendo",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Sortelha",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Souto",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Vale De Espinho",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Vila Boa",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Vila Do Touro",
            freguesiaCode: "39",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aldeia Da Ribeira, Vilar Maior E Badamalos",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "União Das Freguesias De Lajeosa E Forcalhos",
            freguesiaCode: "42",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pousafoles Do Bispo, Pena Lobo E Lomba",
            freguesiaCode: "43",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ruvina, Ruivós E Vale Das Éguas",
            freguesiaCode: "44",
          },
          {
            freguesiaName:
              "União Das Freguesias Do Sabugal E Aldeia De Santo António",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "União Das Freguesias De Santo Estêvão E Moita",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "União Das Freguesias De Seixo Do Côa E Vale Longo",
            freguesiaCode: "47",
          },
        ],
      },
      {
        countyName: "Seia",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Alvoco Da Serra",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Girabolhos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Loriga",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Paranhos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pinhanços",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Sabugueiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Sandomil",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Santa Comba",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Santiago",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Sazes Da Beira",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Teixeira",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Travancinha",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Valezim",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Vila Cova À Coelheira",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Carragozela E Várzea De Meruge",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Sameice E Santa Eulália",
            freguesiaCode: "31",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Marinha E São Martinho",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Seia, São Romão E Lapa Dos Dinheiros",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Torrozelo E Folhadosa",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Tourais E Lajes",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Vide E Cabeça",
            freguesiaCode: "36",
          },
        ],
      },
      {
        countyName: "Trancoso",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Aldeia Nova",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Castanheira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cogula",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cótimos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fiães",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Granja",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Guilheiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Moimentinha",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Moreira De Rei",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Palhais",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Póvoa Do Concelho",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Reboleiro",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Rio De Mel",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Tamanhos",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Valdujo",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Freches E Torres",
            freguesiaCode: "30",
          },
          {
            freguesiaName:
              "União Das Freguesias De Torre Do Terrenho, Sebadelhe Da Serra E Terrenho",
            freguesiaCode: "31",
          },
          {
            freguesiaName:
              "União Das Freguesias De Trancoso (São Pedro E Santa Maria) E Souto Maior",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale Do Seixo E Vila Garcia",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Franca Das Naves E Feital",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Vilares E Carnicães",
            freguesiaCode: "35",
          },
        ],
      },
      {
        countyName: "Vila Nova De Foz Côa",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Almendra",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Castelo Melhor",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cedovim",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Chãs",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Custóias",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Horta",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Muxagata",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Numão",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Santa Comba",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Sebadelhe",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Seixas",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Touça",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Freixo De Numão",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vila Nova De Foz Côa",
            freguesiaCode: "19",
          },
        ],
      },
    ],
  },
  {
    district: "Leiria",
    code: 10,
    county: [
      {
        countyName: "Alcobaça",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Alfeizerão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bárrio",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Benedita",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cela",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Évora De Alcobaça",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Maiorga",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Martinho Do Porto",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Turquel",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vimeiro",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Aljubarrota",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Alcobaça E Vestiaria",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Coz, Alpedriz E Montes",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Pataias E Martingança",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Alvaiázere",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Almoster",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Maçãs De Dona Maria",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Pelmá",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Alvaiázere",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pussos São Pedro",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Ansião",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Alvorge",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Avelar",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Chão De Couce",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Pousaflores",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Santiago Da Guarda",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Ansião",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Batalha",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Batalha",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Reguengo Do Fetal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Mamede",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Golpilheira",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Bombarral",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Carvalhal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Roliça",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Pó",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias Do Bombarral E Vale Covo",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Caldas Da Rainha",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "A Dos Francos",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alvorninha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carvalhal Benfeito",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Foz Do Arelho",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Landal",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Nadadouro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Salir De Matos",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Santa Catarina",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Vidais",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caldas Da Rainha - Nossa Senhora Do Pópulo, Coto E São Gregório",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caldas Da Rainha - Santo Onofre E Serra Do Bouro",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Tornada E Salir Do Porto",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Castanheira De Pêra",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName:
              "União Das Freguesias De Castanheira De Pêra E Coentral",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Figueiró Dos Vinhos",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Aguda",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arega",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Campelo",
            freguesiaCode: "03",
          },
          {
            freguesiaName:
              "União Das Freguesias De Figueiró Dos Vinhos E Bairradas",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Leiria",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Amor",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arrabal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Caranguejeira",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Coimbrão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Maceira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Milagres",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Regueira De Pontes",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Bajouca",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Bidoeira De Cima",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Colmeias E Memória",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Leiria, Pousos, Barreira E Cortes",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Marrazes E Barosa",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Monte Real E Carvide",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Monte Redondo E Carreira",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Parceiros E Azoia",
            freguesiaCode: "37",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Catarina Da Serra E Chainça",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Santa Eufémia E Boa Vista",
            freguesiaCode: "39",
          },
          {
            freguesiaName:
              "União Das Freguesias De Souto Da Carpalhosa E Ortigosa",
            freguesiaCode: "40",
          },
        ],
      },
      {
        countyName: "Marinha Grande",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Marinha Grande",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Vieira De Leiria",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Moita",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Nazaré",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Famalicão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Nazaré",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Valado Dos Frades",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Óbidos",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "A Dos Negros",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Amoreira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Olho Marinho",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vau",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Gaeiras",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Usseira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Santa Maria, São Pedro E Sobral Da Lagoa",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Pedrógão Grande",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Graça",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Pedrógão Grande",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Vila Facaia",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Peniche",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Atouguia Da Baleia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Serra D'El-Rei",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ferrel",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Peniche",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Pombal",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Abiul",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Almagreira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carnide",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Carriço",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Louriçal",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Pelariga",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pombal",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Redinha",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Vermoil",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vila Cã",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Meirinhas",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Guia, Ilha E Mata Mourisca",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santiago E São Simão De Litém E Albergaria Dos Doze",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Porto De Mós",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Alqueidão Da Serra",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Calvaria De Cima",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Juncal",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Mira De Aire",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pedreiras",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Bento",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Serro Ventoso",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Porto De Mós - São João Baptista E São Pedro",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Alvados E Alcaria",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Arrimal E Mendiga",
            freguesiaCode: "16",
          },
        ],
      },
    ],
  },
  {
    district: "Lisboa",
    code: 11,
    county: [
      {
        countyName: "Alenquer",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Carnota",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Meca",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Olhalvo",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Ota",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Ventosa",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vila Verde Dos Francos",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Abrigada E Cabanas De Torres",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aldeia Galega Da Merceana E Aldeia Gavinha",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alenquer (Santo Estêvão E Triana)",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Carregado E Cadafais",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ribafria E Pereiro De Palhacana",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Arruda Dos Vinhos",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Arranhó",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arruda Dos Vinhos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cardosas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santiago Dos Velhos",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Azambuja",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Alcoentre",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Aveiras De Baixo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aveiras De Cima",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Azambuja",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vale Do Paraíso",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Vila Nova Da Rainha",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Manique Do Intendente, Vila Nova De São Pedro E Maçussa",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Cadaval",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Alguber",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Peral",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Vermelha",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Vilar",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias Do Cadaval E Pêro Moniz",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Lamas E Cercal",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Painho E Figueiros",
            freguesiaCode: "13",
          },
        ],
      },
      {
        countyName: "Cascais",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Alcabideche",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "São Domingos De Rana",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Carcavelos E Parede",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias De Cascais E Estoril",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Lisboa",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Ajuda",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alcântara",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Beato",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Benfica",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Campolide",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Carnide",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Lumiar",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Marvila",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Olivais",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "São Domingos De Benfica",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Alvalade",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Areeiro",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "Arroios",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "Avenidas Novas",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "Belém",
            freguesiaCode: "58",
          },
          {
            freguesiaName: "Campo De Ourique",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "Estrela",
            freguesiaCode: "60",
          },
          {
            freguesiaName: "Misericórdia",
            freguesiaCode: "61",
          },
          {
            freguesiaName: "Parque Das Nações",
            freguesiaCode: "62",
          },
          {
            freguesiaName: "Penha De França",
            freguesiaCode: "63",
          },
          {
            freguesiaName: "Santa Clara",
            freguesiaCode: "64",
          },
          {
            freguesiaName: "Santa Maria Maior",
            freguesiaCode: "65",
          },
          {
            freguesiaName: "Santo António",
            freguesiaCode: "66",
          },
          {
            freguesiaName: "São Vicente",
            freguesiaCode: "67",
          },
        ],
      },
      {
        countyName: "Loures",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Bucelas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fanhões",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Loures",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Lousa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Moscavide E Portela",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Sacavém E Prior Velho",
            freguesiaCode: "27",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Iria De Azoia, São João Da Talha E Bobadela",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santo Antão E São Julião Do Tojal",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santo António Dos Cavaleiros E Frielas",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Camarate, Unhos E Apelação",
            freguesiaCode: "31",
          },
        ],
      },
      {
        countyName: "Lourinhã",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Moita Dos Ferreiros",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Reguengo Grande",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Santa Bárbara",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Vimeiro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Ribamar",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Lourinhã E Atalaia",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Miragaia E Marteleira",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Bartolomeu Dos Galegos E Moledo",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Mafra",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Carvoeira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Encarnação",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ericeira",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Mafra",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Milharado",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Santo Isidoro",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Azueira E Sobral Da Abelheira",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Enxara Do Bispo, Gradil E Vila Franca Do Rosário",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Igreja Nova E Cheleiros",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Malveira E São Miguel De Alcainça",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Venda Do Pinheiro E Santo Estêvão Das Galés",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Oeiras",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Barcarena",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Porto Salvo",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Algés, Linda-A-Velha E Cruz Quebrada-Dafundo",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Carnaxide E Queijas",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oeiras E São Julião Da Barra, Paço De Arcos E Caxias",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Sintra",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Algueirão-Mem Martins",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Colares",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Rio De Mouro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Casal De Cambra",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Agualva E Mira-Sintra",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Almargem Do Bispo, Pêro Pinheiro E Montelavar",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias Do Cacém E São Marcos",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Massamá E Monte Abraão",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Queluz E Belas",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De São João Das Lampas E Terrugem",
            freguesiaCode: "27",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sintra (Santa Maria E São Miguel, São Martinho E São Pedro De Penaferrim)",
            freguesiaCode: "28",
          },
        ],
      },
      {
        countyName: "Sobral De Monte Agraço",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Santo Quintino",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Sapataria",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sobral De Monte Agraço",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Torres Vedras",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Freiria",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ponte Do Rol",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ramalhal",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "São Pedro Da Cadeira",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Silveira",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Turcifal",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Ventosa",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De A Dos Cunhados E Maceira",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Campelos E Outeiro Da Cabeça",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Carvoeira E Carmões",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Dois Portos E Runa",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Maxial E Monte Redondo",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Torres Vedras (São Pedro, Santiago, Santa Maria Do Castelo E São Miguel) E Matacães",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Vila Franca De Xira",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Vialonga",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Vila Franca De Xira",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alhandra, São João Dos Montes E Calhandriz",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alverca Do Ribatejo E Sobralinho",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Castanheira Do Ribatejo E Cachoeiras",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Póvoa De Santa Iria E Forte Da Casa",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Amadora",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Alfragide",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Águas Livres",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Encosta Do Sol",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Falagueira-Venda Nova",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Mina De Água",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Venteira",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Odivelas",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Odivelas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "União Das Freguesias De Pontinha E Famões",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Póvoa De Santo Adrião E Olival Basto",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Ramada E Caneças",
            freguesiaCode: "10",
          },
        ],
      },
    ],
  },
  {
    district: "Portalegre",
    code: 12,
    county: [
      {
        countyName: "Alter Do Chão",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Alter Do Chão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Chancelaria",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Seda",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cunheira",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Arronches",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Assunção",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Esperança",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Mosteiros",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Avis",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Aldeia Velha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Avis",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Ervedal",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Figueira E Barros",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Alcórrego E Maranhão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Benavila E Valongo",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Campo Maior",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Nossa Senhora Da Expectação",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Nossa Senhora Da Graça Dos Degolados",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São João Baptista",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Castelo De Vide",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Nossa Senhora Da Graça De Póvoa E Meadas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santa Maria Da Devesa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santiago Maior",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São João Baptista",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Crato",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Aldeia Da Mata",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Gáfete",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Monte Da Pedra",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Crato E Mártires, Flor Da Rosa E Vale Do Peso",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Elvas",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Santa Eulália",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "São Brás E São Lourenço",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São Vicente E Ventosa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Assunção, Ajuda, Salvador E Santo Ildefonso",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Caia, São Pedro E Alcáçova",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Barbacena E Vila Fernando",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Terrugem E Vila Boim",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Fronteira",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Cabeço De Vide",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Fronteira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Saturnino",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Gavião",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Belver",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Comenda",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Margem",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Gavião E Atalaia",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Marvão",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Beirã",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santa Maria De Marvão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo António Das Areias",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Salvador Da Aramenha",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Monforte",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Assumar",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Monforte",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo Aleixo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vaiamonte",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Nisa",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Alpalhão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Montalvão",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Santana",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São Matias",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Tolosa",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Arez E Amieira Do Tejo",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Espírito Santo, Nossa Senhora Da Graça E São Simão",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Ponte De Sor",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Galveias",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Montargil",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Foros De Arrão",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Longomel",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ponte De Sor, Tramaga E Vale De Açor",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Portalegre",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Alagoa",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alegrete",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fortios",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Urra",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias Da Sé E São Lourenço",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Reguengo E São Julião",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ribeira De Nisa E Carreiras",
            freguesiaCode: "13",
          },
        ],
      },
      {
        countyName: "Sousel",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Cano",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Casa Branca",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo Amaro",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Sousel",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Porto",
    code: 13,
    county: [
      {
        countyName: "Amarante",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Ansiães",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Candemil",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Fregim",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Fridão",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Gondar",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Jazente",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Lomba",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Louredo",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Lufrei",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Mancelos",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Padronelo",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Rebordelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Salvador Do Monte",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Gouveia (São Simão)",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Telões",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Travanca",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Vila Caiz",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Vila Chã Do Marão",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União Das Freguesias De Aboadela, Sanche E Várzea",
            freguesiaCode: "41",
          },
          {
            freguesiaName:
              "União Das Freguesias De Amarante (São Gonçalo), Madalena, Cepelos E Gatão",
            freguesiaCode: "42",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bustelo, Carneiro E Carvalho De Rei",
            freguesiaCode: "43",
          },
          {
            freguesiaName:
              "União Das Freguesias De Figueiró (Santiago E Santa Cristina)",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "União Das Freguesias De Freixo De Cima E De Baixo",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "União Das Freguesias De Olo E Canadelo",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "Vila Meã",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Garcia, Aboim E Chapa",
            freguesiaCode: "48",
          },
        ],
      },
      {
        countyName: "Baião",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Frende",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Gestaçô",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Gove",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Grilo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Loivos Do Monte",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Santa Marinha Do Zêzere",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Valadares",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Viariz",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Ancede E Ribadouro",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Baião (Santa Leocádia) E Mesquinhata",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Campelo E Ovil",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De Loivos Da Ribeira E Tresouras",
            freguesiaCode: "24",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Cruz Do Douro E São Tomé De Covelas",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Teixeira E Teixeiró",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Felgueiras",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Aião",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Airães",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Friande",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Idães",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Jugueiros",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Penacova",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Pombeiro De Ribavizela",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Refontoura",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Regilde",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Revinhade",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Sendim",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Macieira Da Lixa E Caramos",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Margaride (Santa Eulália), Várzea, Lagares, Varziela E Moure",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Pedreira, Rande E Sernande",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Torrados E Sousa",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União Das Freguesias De Unhão E Lordelo",
            freguesiaCode: "38",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Cova Da Lixa E Borba De Godim",
            freguesiaCode: "39",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Fria E Vizela (São Jorge)",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Verde E Santão",
            freguesiaCode: "41",
          },
        ],
      },
      {
        countyName: "Gondomar",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Lomba",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Rio Tinto",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Baguim Do Monte (Rio Tinto)",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Fânzeres E São Pedro Da Cova",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Foz Do Sousa E Covelo",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Gondomar (São Cosme), Valbom E Jovim",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Melres E Medas",
            freguesiaCode: "16",
          },
        ],
      },
      {
        countyName: "Lousada",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Aveleda",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Caíde De Rei",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Lodares",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Macieira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Meinedo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Nevogilde",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Sousela",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Torno",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Vilar Do Torno E Alentém",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cernadelo E Lousada (São Miguel E Santa Margarida)",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Cristelos, Boim E Ordem",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "União Das Freguesias De Figueiras E Covas",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lustosa E Barrosas (Santo Estêvão)",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Nespereira E Casais",
            freguesiaCode: "31",
          },
          {
            freguesiaName:
              "União Das Freguesias De Silvares, Pias, Nogueira E Alvarenga",
            freguesiaCode: "32",
          },
        ],
      },
      {
        countyName: "Maia",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Águas Santas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Folgosa",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Milheirós",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Moreira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Pedro Fins",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vila Nova Da Telha",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Pedrouços",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Castêlo Da Maia",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Cidade Da Maia",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Nogueira E Silva Escura",
            freguesiaCode: "20",
          },
        ],
      },
      {
        countyName: "Marco De Canaveses",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Banho E Carvalhosa",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Constance",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Soalhães",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Sobretâmega",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Tabuado",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Vila Boa Do Bispo",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Alpendorada, Várzea E Torrão",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Avessadas E Rosém",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Bem Viver",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Santo Isidoro E Livração",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Marco",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Paredes De Viadores E Manhuncelos",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Penhalonga E Paços De Gaiolo",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Sande E São Lourenço Do Douro",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Várzea, Aliviada E Folhada",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Vila Boa De Quires E Maureles",
            freguesiaCode: "41",
          },
        ],
      },
      {
        countyName: "Matosinhos",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName:
              "União Das Freguesias De Custóias, Leça Do Balio E Guifões",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Matosinhos E Leça Da Palmeira",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De Perafita, Lavra E Santa Cruz Do Bispo",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Mamede De Infesta E Senhora Da Hora",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Paços De Ferreira",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Carvalhosa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Eiriz",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ferreira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Figueiró",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Freamunde",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Meixomil",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Penamaior",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Raimonda",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Seroa",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Frazão Arreigada",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Paços De Ferreira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Sanfins Lamoso Codessos",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Paredes",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Aguiar De Sousa",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Astromil",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Baltar",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Beire",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cete",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Cristelo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Duas Igrejas",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Gandra",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Lordelo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Louredo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Parada De Todeia",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Rebordosa",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Recarei",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Sobreira",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Sobrosa",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Vandoma",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Vilela",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Paredes",
            freguesiaCode: "25",
          },
        ],
      },
      {
        countyName: "Penafiel",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Abragão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Boelhe",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bustelo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cabeça Santa",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Canelas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Capela",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Castelões",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Croca",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Duas Igrejas",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Eja",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Fonte Arcada",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Galegos",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Irivo",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Oldrões",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Paço De Sousa",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Perozelo",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Rans",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Rio De Moinhos",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Recezinhos (São Mamede)",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Recezinhos (São Martinho)",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Sebolido",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Valpedre",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Rio Mau",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Penafiel",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Luzim E Vila Cova",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Guilhufe E Urrô",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "Lagares E Figueira",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Termas De São Vicente",
            freguesiaCode: "43",
          },
        ],
      },
      {
        countyName: "Porto",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Bonfim",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Campanhã",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Paranhos",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ramalde",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aldoar, Foz Do Douro E Nevogilde",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cedofeita, Santo Ildefonso, Sé, Miragaia, São Nicolau E Vitória",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lordelo Do Ouro E Massarelos",
            freguesiaCode: "18",
          },
        ],
      },
      {
        countyName: "Póvoa De Varzim",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Balazar",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Estela",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Laundos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Rates",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Aver-O-Mar, Amorim E Terroso",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Aguçadoura E Navais",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias Da Póvoa De Varzim, Beiriz E Argivai",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Santo Tirso",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Agrela",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Água Longa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aves",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Monte Córdova",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Rebordões",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Reguenga",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Roriz",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Negrelos (São Tomé)",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Vilarinho",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Areias, Sequeiró, Lama E Palmeira",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De Campo (São Martinho), São Salvador Do Campo E Negrelos (São Mamede)",
            freguesiaCode: "34",
          },
          {
            freguesiaName:
              "União Das Freguesias De Carreira E Refojos De Riba De Ave",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Lamelas E Guimarei",
            freguesiaCode: "36",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santo Tirso, Couto (Santa Cristina E São Miguel) E Burgães",
            freguesiaCode: "37",
          },
        ],
      },
      {
        countyName: "Valongo",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Alfena",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ermesinde",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Valongo",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "União Das Freguesias De Campo E Sobrado",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Vila Do Conde",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Árvore",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Aveleda",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Azurara",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Fajozes",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Gião",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Guilhabreu",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Junqueira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Labruge",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Macieira Da Maia",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Mindelo",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Modivas",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vila Chã",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Vila Do Conde",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Vilar De Pinheiro",
            freguesiaCode: "30",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bagunte, Ferreiró, Outeiro Maior E Parada",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Fornelo E Vairão",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "União Das Freguesias De Malta E Canidelo",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Retorta E Tougues",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Rio Mau E Arcos",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Touguinha E Touguinhó",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Vilar E Mosteiró",
            freguesiaCode: "37",
          },
        ],
      },
      {
        countyName: "Vila Nova De Gaia",
        countyCode: "17",
        fregusias: [
          {
            freguesiaName: "Arcozelo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Avintes",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Canelas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Canidelo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Madalena",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Oliveira Do Douro",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "São Félix Da Marinha",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vilar De Andorinho",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Grijó E Sermonde",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Gulpilhares E Valadares",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mafamude E Vilar Do Paraíso",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Pedroso E Seixezelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Sandim, Olival, Lever E Crestuma",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Marinha E São Pedro Da Afurada",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Serzedo E Perosinho",
            freguesiaCode: "31",
          },
        ],
      },
      {
        countyName: "Trofa",
        countyCode: "18",
        fregusias: [
          {
            freguesiaName: "Covelas",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Muro",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Alvarelhos E Guidões",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bougado (São Martinho E Santiago)",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Coronado (São Romão E São Mamede)",
            freguesiaCode: "11",
          },
        ],
      },
    ],
  },
  {
    district: "Santarém",
    code: 14,
    county: [
      {
        countyName: "Abrantes",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Bemposta",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Martinchel",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Mouriscas",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Pego",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Rio De Moinhos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Tramagal",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Fontes",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Carvalhal",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Abrantes (São Vicente E São João) E Alferrarede",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Aldeia Do Mato E Souto",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Alvega E Concavada",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De São Facundo E Vale Das Mós",
            freguesiaCode: "23",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Miguel Do Rio Torto E Rossio Ao Sul Do Tejo",
            freguesiaCode: "24",
          },
        ],
      },
      {
        countyName: "Alcanena",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Bugalhos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Minde",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Moitas Venda",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Monsanto",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Serra De Santo António",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Alcanena E Vila Moreira",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Malhou, Louriceira E Espinheiro",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Almeirim",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Almeirim",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Benfica Do Ribatejo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fazendas De Almeirim",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Raposa",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Alpiarça",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Alpiarça",
            freguesiaCode: "01",
          },
        ],
      },
      {
        countyName: "Benavente",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Benavente",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Samora Correia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo Estêvão",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Barrosa",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Cartaxo",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Pontével",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Valada",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Vila Chã De Ourique",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Vale Da Pedra",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias Do Cartaxo E Vale Da Pinta",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Ereira E Lapa",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Chamusca",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Ulme",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vale De Cavalos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Carregueira",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "União Das Freguesias Da Chamusca E Pinheiro Grande",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Parreira E Chouto",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Constância",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Constância",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Montalvo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santa Margarida Da Coutada",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Coruche",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Couço",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São José Da Lamarosa",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Branca",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Biscainho",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Santana Do Mato",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Coruche, Fajarda E Erra",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Entroncamento",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "São João Baptista",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Nossa Senhora De Fátima",
            freguesiaCode: "02",
          },
        ],
      },
      {
        countyName: "Ferreira Do Zêzere",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Águas Belas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Beco",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Chãos",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ferreira Do Zêzere",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Igreja Nova Do Sobral",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Nossa Senhora Do Pranto",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Areias E Pias",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Golegã",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Azinhaga",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Golegã",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pombalinho",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Mação",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Amêndoa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cardigos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carvoeiro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Envendos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ortiga",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mação, Penhascoso E Aboboreira",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Rio Maior",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Alcobertas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arrouquelas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fráguas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Rio Maior",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Asseiceira",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "São Sebastião",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Azambujeira E Malaqueijo",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Marmeleira E Assentiz",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias De Outeiro Da Cortiçada E Arruda Dos Pisões",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De São João Da Ribeira E Ribeira De São João",
            freguesiaCode: "18",
          },
        ],
      },
      {
        countyName: "Salvaterra De Magos",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Marinhais",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Muge",
            freguesiaCode: "03",
          },
          {
            freguesiaName:
              "União Das Freguesias De Glória Do Ribatejo E Granho",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Salvaterra De Magos E Foros De Salvaterra",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Santarém",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Abitureiras",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Abrã",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Alcanede",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Alcanhões",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Almoster",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Amiais De Baixo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Arneiro Das Milhariças",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Moçarria",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Pernes",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Póvoa Da Isenta",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Vale De Santarém",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Gançaria",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Achete, Azoia De Baixo E Póvoa De Santarém",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "União Das Freguesias De Azoia De Cima E Tremês",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "União Das Freguesias De Casével E Vaqueiros",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Romeira E Várzea",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santarém (Marvila), Santa Iria Da Ribeira De Santarém, Santarém (São Salvador) E Santarém (São Nicolau)",
            freguesiaCode: "33",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Vicente Do Paul E Vale De Figueira",
            freguesiaCode: "34",
          },
        ],
      },
      {
        countyName: "Sardoal",
        countyCode: "17",
        fregusias: [
          {
            freguesiaName: "Alcaravela",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santiago De Montalegre",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Sardoal",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Valhascos",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Tomar",
        countyCode: "18",
        fregusias: [
          {
            freguesiaName: "Asseiceira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Carregueiros",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Olalhas",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Paialvo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Pedro De Tomar",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Sabacheira",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Além Da Ribeira E Pedreira",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Casais E Alviobeira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Madalena E Beselga",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Serra E Junceira",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tomar (São João Baptista) E Santa Maria Dos Olivais",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Torres Novas",
        countyCode: "19",
        fregusias: [
          {
            freguesiaName: "Assentiz",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Chancelaria",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Pedrógão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Riachos",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Zibreira",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Meia Via",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Brogueira, Parceiros De Igreja E Alcorochel",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Olaia E Paço",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Torres Novas (Santa Maria, Salvador E Santiago)",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Torres Novas (São Pedro), Lapas E Ribeira Branca",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Vila Nova Da Barquinha",
        countyCode: "20",
        fregusias: [
          {
            freguesiaName: "Atalaia",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Praia Do Ribatejo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Tancos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Nova Da Barquinha",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Ourém",
        countyCode: "21",
        fregusias: [
          {
            freguesiaName: "Alburitel",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Atouguia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Caxarias",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Espite",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fátima",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Nossa Senhora Das Misericórdias",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Seiça",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Urqueira",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Nossa Senhora Da Piedade",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De Freixianda, Ribeira Do Fárrio E Formigais",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Gondemaria E Olival",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Matas E Cercal",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Rio De Couros E Casal Dos Bernardos",
            freguesiaCode: "22",
          },
        ],
      },
    ],
  },
  {
    district: "Setúbal",
    code: 15,
    county: [
      {
        countyName: "Alcácer Do Sal",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Torrão",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Martinho",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Comporta",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alcácer Do Sal (Santa Maria Do Castelo E Santiago) E Santa Susana",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Alcochete",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Alcochete",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Samouco",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Francisco",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Almada",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Costa Da Caparica",
            freguesiaCode: "03",
          },
          {
            freguesiaName:
              "União Das Freguesias De Almada, Cova Da Piedade, Pragal E Cacilhas",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Caparica E Trafaria",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Charneca De Caparica E Sobreda",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Laranjeiro E Feijó",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Barreiro",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Santo António Da Charneca",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alto Do Seixalinho, Santo André E Verderena",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Barreiro E Lavradio",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Palhais E Coina",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Grândola",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Azinheira Dos Barros E São Mamede Do Sádão",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Melides",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Carvalhal",
            freguesiaCode: "05",
          },
          {
            freguesiaName:
              "União Das Freguesias De Grândola E Santa Margarida Da Serra",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Moita",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Alhos Vedros",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Moita",
            freguesiaCode: "03",
          },
          {
            freguesiaName:
              "União Das Freguesias De Baixa Da Banheira E Vale Da Amoreira",
            freguesiaCode: "07",
          },
          {
            freguesiaName:
              "União Das Freguesias De Gaio-Rosário E Sarilhos Pequenos",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Montijo",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Canha",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Sarilhos Grandes",
            freguesiaCode: "04",
          },
          {
            freguesiaName:
              "União Das Freguesias De Atalaia E Alto Estanqueiro-Jardia",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Montijo E Afonsoeiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Pegões",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Palmela",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Palmela",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pinhal Novo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Quinta Do Anjo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "União Das Freguesias De Poceirão E Marateca",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Santiago Do Cacém",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Abela",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alvalade",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cercal",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Ermidas-Sado",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santo André",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São Francisco Da Serra",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santiago Do Cacém, Santa Cruz E São Bartolomeu Da Serra",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Domingos E Vale De Água",
            freguesiaCode: "13",
          },
        ],
      },
      {
        countyName: "Seixal",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Amora",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Corroios",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fernão Ferro",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias Do Seixal, Arrentela E Aldeia De Paio Pires",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Sesimbra",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Sesimbra (Castelo)",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Sesimbra (Santiago)",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Quinta Do Conde",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Setúbal",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Setúbal (São Sebastião)",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Gâmbia-Pontes-Alto Da Guerra",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Sado",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Azeitão (São Lourenço E São Simão)",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Setúbal (São Julião, Nossa Senhora Da Anunciada E Santa Maria Da Graça)",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Sines",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Sines",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Porto Covo",
            freguesiaCode: "02",
          },
        ],
      },
    ],
  },
  {
    district: "Viana Do Castelo",
    code: 16,
    county: [
      {
        countyName: "Arcos De Valdevez",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Aboim Das Choças",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Aguiã",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ázere",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cabana Maior",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cabreiro",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Cendufe",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Couto",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Gavieira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Gondoriz",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Miranda",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Monte Redondo",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Oliveira",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Paçô",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Padroso",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Prozelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Rio Frio",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Rio De Moinhos",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Sabadim",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Jolda (São Paio)",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Senharei",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Sistelo",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "Soajo",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "Vale",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "União Das Freguesias De Alvora E Loureda",
            freguesiaCode: "52",
          },
          {
            freguesiaName:
              "União Das Freguesias De Arcos De Valdevez (São Paio) E Giela",
            freguesiaCode: "53",
          },
          {
            freguesiaName:
              "União Das Freguesias De Arcos De Valdevez (Salvador), Vila Fonche E Parada",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "União Das Freguesias De Eiras E Mei",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "União Das Freguesias De Grade E Carralcova",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "União Das Freguesias De Guilhadeses E Santar",
            freguesiaCode: "57",
          },
          {
            freguesiaName:
              "União Das Freguesias De Jolda (Madalena) E Rio Cabrão",
            freguesiaCode: "58",
          },
          {
            freguesiaName:
              "União Das Freguesias De Padreiro (Salvador E Santa Cristina)",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "União Das Freguesias De Portela E Extremo",
            freguesiaCode: "60",
          },
          {
            freguesiaName: "União Das Freguesias De São Jorge E Ermelo",
            freguesiaCode: "61",
          },
          {
            freguesiaName: "União Das Freguesias De Souto E Tabaçô",
            freguesiaCode: "62",
          },
          {
            freguesiaName:
              "União Das Freguesias De Távora (Santa Maria E São Vicente)",
            freguesiaCode: "63",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilela, São Cosme E São Damião E Sá",
            freguesiaCode: "64",
          },
        ],
      },
      {
        countyName: "Caminha",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Âncora",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Argela",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Dem",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Lanhelas",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Riba De Âncora",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Seixas",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Vila Praia De Âncora",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vilar De Mouros",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vile",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Arga (Baixo, Cima E São João)",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Caminha (Matriz) E Vilarelho",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Gondar E Orbacém",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Moledo E Cristelo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Venade E Azevedo",
            freguesiaCode: "25",
          },
        ],
      },
      {
        countyName: "Melgaço",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Alvaredo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cousso",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cristoval",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fiães",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Gave",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Paderne",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Penso",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Paio",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Castro Laboreiro E Lamas De Mouro",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Chaviães E Paços",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Parada Do Monte E Cubalhão",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Prado E Remoães",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Vila E Roussas",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Monção",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Abedim",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Barbeita",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Barroças E Taias",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Bela",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Cambeses",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Lara",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Longos Vales",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Merufe",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Moreira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Pias",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Pinheiros",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Podame",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Portela",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Riba De Mouro",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Segude",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Tangil",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Trute",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Anhões E Luzio",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Ceivães E Badim",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Mazedo E Cortes",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Messegães, Valadares E Sá",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União Das Freguesias De Monção E Troviscoso",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Sago, Lordelo E Parada",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União Das Freguesias De Troporiz E Lapela",
            freguesiaCode: "40",
          },
        ],
      },
      {
        countyName: "Paredes De Coura",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Agualonga",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Castanheira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Coura",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cunha",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Infesta",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Mozelos",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Padornelo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Parada",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Romarigães",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Rubiães",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Vascões",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Bico E Cristelo",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Cossourado E Linhares",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Formariz E Ferreira",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Insalde E Porreiras",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Paredes De Coura E Resende",
            freguesiaCode: "26",
          },
        ],
      },
      {
        countyName: "Ponte Da Barca",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Azias",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Boivães",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bravães",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Britelo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cuide De Vila Verde",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Lavradas",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Lindoso",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Nogueira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Oleiros",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Sampriz",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Vade (São Pedro)",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Vade (São Tomé)",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Crasto, Ruivos E Grovelas",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Entre Ambos-Os-Rios, Ermida E Germil",
            freguesiaCode: "27",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ponte Da Barca, Vila Nova De Muía E Paço Vedro De Magalhães",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Touvedo (São Lourenço E Salvador)",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Chã (São João Baptista E Santiago)",
            freguesiaCode: "30",
          },
        ],
      },
      {
        countyName: "Ponte De Lima",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Anais",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "São Pedro D'Arcos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Arcozelo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Beiral Do Lima",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Bertiandos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Boalhosa",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Brandara",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Calheiros",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Calvelo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Correlhã",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Estorãos",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Facha",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Feitosa",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Fontão",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Friastelas",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Gandra",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Gemieira",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Gondufe",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Labruja",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Poiares",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Refóios Do Lima",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Ribeira",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "Sá",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Santa Comba",
            freguesiaCode: "42",
          },
          {
            freguesiaName: "Santa Cruz Do Lima",
            freguesiaCode: "43",
          },
          {
            freguesiaName: "Rebordões (Santa Maria)",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Seara",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "Serdedelo",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "Rebordões (Souto)",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Vitorino Das Donas",
            freguesiaCode: "50",
          },
          {
            freguesiaName: "Arca E Ponte De Lima",
            freguesiaCode: "52",
          },
          {
            freguesiaName: "Ardegão, Freixo E Mato",
            freguesiaCode: "53",
          },
          {
            freguesiaName: "Associação De Freguesias Do Vale Do Neiva",
            freguesiaCode: "54",
          },
          {
            freguesiaName: "Bárrio E Cepões",
            freguesiaCode: "55",
          },
          {
            freguesiaName: "Cabaços E Fojo Lobal",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "Cabração E Moreira Do Lima",
            freguesiaCode: "57",
          },
          {
            freguesiaName: "Fornelos E Queijada",
            freguesiaCode: "58",
          },
          {
            freguesiaName: "Labrujó, Rendufe E Vilar Do Monte",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "Navió E Vitorino Dos Piães",
            freguesiaCode: "60",
          },
        ],
      },
      {
        countyName: "Valença",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Boivão",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cerdal",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Fontoura",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Friestas",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ganfei",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "São Pedro Da Torre",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Verdoejo",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Gandra E Taião",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Gondomil E Sanfins",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De São Julião E Silva",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Valença, Cristelo Covo E Arão",
            freguesiaCode: "20",
          },
        ],
      },
      {
        countyName: "Viana Do Castelo",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Afife",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alvarães",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Amonde",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Anha",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Areosa",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Carreço",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Castelo Do Neiva",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Darque",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Freixieiro De Soutelo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Lanheses",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Montaria",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Mujães",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "São Romão De Neiva",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Outeiro",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Perre",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Santa Marta De Portuzelo",
            freguesiaCode: "28",
          },
          {
            freguesiaName: "Vila Franca",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Vila De Punhe",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Chafé",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União Das Freguesias De Barroselas E Carvoeiro",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "União Das Freguesias De Cardielos E Serreleis",
            freguesiaCode: "42",
          },
          {
            freguesiaName:
              "União Das Freguesias De Geraz Do Lima (Santa Maria, Santa Leocádia E Moreira) E Deão",
            freguesiaCode: "43",
          },
          {
            freguesiaName: "União Das Freguesias De Mazarefes E Vila Fria",
            freguesiaCode: "44",
          },
          {
            freguesiaName:
              "União Das Freguesias De Nogueira, Meixedo E Vilar De Murteda",
            freguesiaCode: "45",
          },
          {
            freguesiaName:
              "União Das Freguesias De Subportela, Deocriste E Portela Susã",
            freguesiaCode: "46",
          },
          {
            freguesiaName: "União Das Freguesias De Torre E Vila Mou",
            freguesiaCode: "47",
          },
          {
            freguesiaName:
              "União Das Freguesias De Viana Do Castelo (Santa Maria Maior E Monserrate) E Meadela",
            freguesiaCode: "48",
          },
        ],
      },
      {
        countyName: "Vila Nova De Cerveira",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Cornes",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Covas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Gondarém",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Loivo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Mentrestido",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Sapardos",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Sopo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Campos E Vila Meã",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Candemil E Gondar",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Reboreda E Nogueira",
            freguesiaCode: "18",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Nova De Cerveira E Lovelhe",
            freguesiaCode: "19",
          },
        ],
      },
    ],
  },
  {
    district: "Vila Real",
    code: 17,
    county: [
      {
        countyName: "Alijó",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Alijó",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Favaios",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Pegarinhos",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pinhão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Sanfins Do Douro",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Santa Eugénia",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Mamede De Ribatua",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vila Chã",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Vila Verde",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vilar De Maçada",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Carlão E Amieiro",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Castedo E Cotas",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De Pópulo E Ribalonga",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vale De Mendiz, Casal De Loivos E Vilarinho De Cotas",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Boticas",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Beça",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Covas Do Barroso",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Dornelas",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Pinho",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Sapiãos",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Alturas Do Barroso E Cerdedo",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Ardãos E Bobadela",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Boticas E Granja",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Codessoso, Curros E Fiães Do Tâmega",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Vilar E Viveiro",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Chaves",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Águas Frias",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Anelhe",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bustelo",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cimo De Vila Da Castanheira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Curalha",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ervededo",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Faiões",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Lama De Arcos",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Mairos",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Moreiras",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Nogueira Da Montanha",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Oura",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Outeiro Seco",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Paradela",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Redondelo",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Sanfins",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Santa Leocádia",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Santo António De Monforte",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Santo Estêvão",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "São Pedro De Agostém",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "São Vicente",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Tronco",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Vale De Anta",
            freguesiaCode: "41",
          },
          {
            freguesiaName: "Vila Verde Da Raia",
            freguesiaCode: "43",
          },
          {
            freguesiaName: "Vilar De Nantes",
            freguesiaCode: "44",
          },
          {
            freguesiaName: "Vilarelho Da Raia",
            freguesiaCode: "45",
          },
          {
            freguesiaName: "Vilas Boas",
            freguesiaCode: "47",
          },
          {
            freguesiaName: "Vilela Seca",
            freguesiaCode: "48",
          },
          {
            freguesiaName: "Vilela Do Tâmega",
            freguesiaCode: "49",
          },
          {
            freguesiaName: "Santa Maria Maior",
            freguesiaCode: "50",
          },
          {
            freguesiaName:
              "Planalto De Monforte (União Das Freguesias De Oucidres E Bobadela)",
            freguesiaCode: "53",
          },
          {
            freguesiaName: "União Das Freguesias Da Madalena E Samaiões",
            freguesiaCode: "54",
          },
          {
            freguesiaName:
              "União Das Freguesias Das Eiras, São Julião De Montenegro E Cela",
            freguesiaCode: "55",
          },
          {
            freguesiaName:
              "União Das Freguesias De Calvão E Soutelinho Da Raia",
            freguesiaCode: "56",
          },
          {
            freguesiaName: "União Das Freguesias De Loivos E Póvoa De Agrações",
            freguesiaCode: "57",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Cruz/Trindade E Sanjurge",
            freguesiaCode: "58",
          },
          {
            freguesiaName: "União Das Freguesias De Soutelo E Seara Velha",
            freguesiaCode: "59",
          },
          {
            freguesiaName: "União Das Freguesias De Travancas E Roriz",
            freguesiaCode: "60",
          },
          {
            freguesiaName:
              "Vidago (União Das Freguesias De Vidago, Arcossó, Selhariz E Vilarinho Das Paranheiras)",
            freguesiaCode: "61",
          },
        ],
      },
      {
        countyName: "Mesão Frio",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Barqueiros",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cidadelhe",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Oliveira",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Marim",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Mesão Frio (Santo André)",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Mondim De Basto",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Atei",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Bilhó",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Cristóvão De Mondim De Basto",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Vilar De Ferreiros",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Campanhó E Paradança",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Ermelo E Pardelhas",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Montalegre",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Cabril",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cervos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Chã",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Covelo Do Gerês",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Ferral",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Gralhas",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Morgade",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Negrões",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Outeiro",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Pitões Das Junias",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Reigoso",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "Salto",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Santo André",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Sarraquinhos",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Solveira",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Tourém",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Vila Da Ponte",
            freguesiaCode: "35",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cambeses Do Rio, Donões E Mourilhe",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "União Das Freguesias De Meixedo E Padornelos",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União Das Freguesias De Montalegre E Padroso",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "União Das Freguesias De Paradela, Contim E Fiães",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "União Das Freguesias De Sezelhe E Covelães",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "União Das Freguesias De Venda Nova E Pondras",
            freguesiaCode: "41",
          },
          {
            freguesiaName:
              "União Das Freguesias De Viade De Baixo E Fervidelas",
            freguesiaCode: "42",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilar De Perdizes E Meixide",
            freguesiaCode: "43",
          },
        ],
      },
      {
        countyName: "Murça",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Candedo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Fiolhoso",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Jou",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Murça",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Valongo De Milhais",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "União Das Freguesias De Carva E Vilares",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Noura E Palheiros",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Peso Da Régua",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Fontelas",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Loureiro",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Sedielos",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Vilarinho Dos Freires",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Galafura E Covelinhas",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Moura Morta E Vinhós",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Peso Da Régua E Godim",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Poiares E Canelas",
            freguesiaCode: "16",
          },
        ],
      },
      {
        countyName: "Ribeira De Pena",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Alvadia",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Canedo",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santa Marinha",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Cerva E Limões",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Ribeira De Pena (Salvador) E Santo Aleixo De Além-Tâmega",
            freguesiaCode: "09",
          },
        ],
      },
      {
        countyName: "Sabrosa",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Celeirós",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Covas Do Douro",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Gouvinhas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Parada De Pinhão",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Paços",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Sabrosa",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Lourenço De Ribapinhão",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Souto Maior",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Torre Do Pinhão",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vilarinho De São Romão",
            freguesiaCode: "15",
          },
          {
            freguesiaName:
              "União Das Freguesias De Provesende, Gouvães Do Douro E São Cristóvão Do Douro",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Martinho De Antas E Paradela De Guiães",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "Santa Marta De Penaguião",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Alvações Do Corgo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cumieira",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fontes",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Medrões",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Sever",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Lobrigos (São Miguel E São João Baptista) E Sanhoane",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Louredo E Fornelos",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "Valpaços",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Água Revés E Crasto",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Algeriz",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Bouçoães",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Canaveses",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ervões",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Fornos Do Pinhal",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Friões",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Padrela E Tazem",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Possacos",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Rio Torto",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Santa Maria De Emeres",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Santa Valha",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Santiago Da Ribeira De Alhariz",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "São João Da Corveira",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "São Pedro De Veiga De Lila",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Serapicos",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Vales",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "Vassal",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "Veiga De Lila",
            freguesiaCode: "30",
          },
          {
            freguesiaName: "Vilarandelo",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "Carrazedo De Montenegro E Curros",
            freguesiaCode: "32",
          },
          {
            freguesiaName: "Lebução, Fiães E Nozelos",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "Sonim E Barreiros",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "Tinhela E Alvarelhos",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "Valpaços E Sanfins",
            freguesiaCode: "36",
          },
        ],
      },
      {
        countyName: "Vila Pouca De Aguiar",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Alfarela De Jales",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Bornes De Aguiar",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Bragado",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Capeludos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Soutelo De Aguiar",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Telões",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Tresminas",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Valoura",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Vila Pouca De Aguiar",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vreia De Bornes",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Vreia De Jales",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Sabroso De Aguiar",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Alvão",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pensalvos E Parada De Monteiros",
            freguesiaCode: "20",
          },
        ],
      },
      {
        countyName: "Vila Real",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Abaças",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Andrães",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Arroios",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Campeã",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Folhadela",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Guiães",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Lordelo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Mateus",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Mondrões",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Parada De Cunhos",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Torgueda",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "Vila Marim",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De Adoufe E Vilarinho De Samardã",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Borbela E Lamas De Olo",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Constantim E Vale De Nogueiras",
            freguesiaCode: "33",
          },
          {
            freguesiaName: "União Das Freguesias De Mouçós E Lamares",
            freguesiaCode: "34",
          },
          {
            freguesiaName: "União Das Freguesias De Nogueira E Ermida",
            freguesiaCode: "35",
          },
          {
            freguesiaName: "União Das Freguesias De Pena, Quintã E Vila Cova",
            freguesiaCode: "36",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Tomé Do Castelo E Justes",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "Vila Real",
            freguesiaCode: "38",
          },
        ],
      },
    ],
  },
  {
    district: "Viseu",
    code: 18,
    county: [
      {
        countyName: "Armamar",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Aldeias",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cimbres",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Folgosa",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Fontelo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Queimada",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Queimadela",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Santa Cruz",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "São Cosmado",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "São Martinho Das Chãs",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Vacalar",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Armamar",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Aricera E Goujoim",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "União Das Freguesias De São Romão E Santiago",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Seca E Santo Adrião",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Carregal Do Sal",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Beijós",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cabanas De Viriato",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Oliveira Do Conde",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Parada",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Currelos, Papízios E Sobral",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Castro Daire",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Almofala",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cabril",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Castro Daire",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cujó",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Gosende",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Mões",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Moledo",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Monteiras",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Pepim",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "São Joaninho",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Mamouros, Alva E Ribolhos",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "União Das Freguesias De Mezio E Moura Morta",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "União Das Freguesias De Parada De Ester E Ester",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "União Das Freguesias De Picão E Ermida",
            freguesiaCode: "26",
          },
          {
            freguesiaName: "União Das Freguesias De Reriz E Gafanhão",
            freguesiaCode: "27",
          },
        ],
      },
      {
        countyName: "Cinfães",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Cinfães",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Espadanedo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ferreiros De Tendais",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fornelos",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Moimenta",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Nespereira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Oliveira Do Douro",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Santiago De Piães",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "São Cristóvão De Nogueira",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Souselo",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Tarouquela",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Tendais",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Travanca",
            freguesiaCode: "17",
          },
          {
            freguesiaName:
              "União Das Freguesias De Alhões, Bustelo, Gralheira E Ramires",
            freguesiaCode: "18",
          },
        ],
      },
      {
        countyName: "Lamego",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Avões",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Britiande",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Cambres",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ferreirim",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Ferreiros De Avões",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Figueira",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Lalim",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Lazarim",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Penajóia",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Penude",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Samodães",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Sande",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Várzea De Abrunhais",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Vila Nova De Souto D'El-Rei",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Lamego (Almacave E Sé)",
            freguesiaCode: "25",
          },
          {
            freguesiaName:
              "União Das Freguesias De Bigorne, Magueija E Pretarouca",
            freguesiaCode: "26",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cepões, Meijinhos E Melcões",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Parada Do Bispo E Valdigem",
            freguesiaCode: "28",
          },
        ],
      },
      {
        countyName: "Mangualde",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Abrunhosa-A-Velha",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Alcafache",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cunha Baixa",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Espinho",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Fornos De Maceira Dão",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Freixiosa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Quintela De Azurara",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "São João Da Fresta",
            freguesiaCode: "16",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mangualde, Mesquitela E Cunha Alta",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Moimenta De Maceira Dão E Lobelhe Do Mato",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santiago De Cassurrães E Póvoa De Cervães",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Tavares (Chãs, Várzea E Travanca)",
            freguesiaCode: "22",
          },
        ],
      },
      {
        countyName: "Moimenta Da Beira",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Alvite",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Arcozelos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Baldos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cabaços",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Caria",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Castelo",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Leomil",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Moimenta Da Beira",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Passô",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Rua",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Sarzedo",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Sever",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Vilar",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Paradinha E Nagosa",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pêra Velha, Aldeia De Nacomba E Ariz",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "União Das Freguesias De Peva E Segões",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Mortágua",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Cercosa",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Espinho",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Marmeleira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Pala",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Sobral",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Trezói",
            freguesiaCode: "09",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mortágua, Vale De Remígio, Cortegaça E Almaça",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Nelas",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Canas De Senhorim",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Nelas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Senhorim",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Vilar Seco",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Lapa Do Lobo",
            freguesiaCode: "08",
          },
          {
            freguesiaName:
              "União Das Freguesias De Carvalhal Redondo E Aguieira",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Santar E Moreira",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Oliveira De Frades",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Arcozelo Das Maias",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Pinheiro",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ribeiradio",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São João Da Serra",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "São Vicente De Lafões",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Arca E Varzielas",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "União Das Freguesias De Destriz E Reigoso",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Oliveira De Frades, Souto De Lafões E Sejães",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Penalva Do Castelo",
        countyCode: "11",
        fregusias: [
          {
            freguesiaName: "Castelo De Penalva",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Esmolfe",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Germil",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ínsua",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Lusinde",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Pindo",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Real",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Sezures",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Trancozelos",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Antas E Matela",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "União Das Freguesias De Vila Cova Do Covelo/Mareco",
            freguesiaCode: "15",
          },
        ],
      },
      {
        countyName: "Penedono",
        countyCode: "12",
        fregusias: [
          {
            freguesiaName: "Beselga",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Castainço",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Penela Da Beira",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Póvoa De Penela",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Souto",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Antas E Ourozinho",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "União Das Freguesias De Penedono E Granja",
            freguesiaCode: "11",
          },
        ],
      },
      {
        countyName: "Resende",
        countyCode: "13",
        fregusias: [
          {
            freguesiaName: "Barrô",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cárquere",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Paus",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Resende",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "São Cipriano",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "São João De Fontoura",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Martinho De Mouros",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Anreade E São Romão De Aregos",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Felgueiras E Feirão",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Freigil E Miomães",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Ovadas E Panchorra",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Santa Comba Dão",
        countyCode: "14",
        fregusias: [
          {
            freguesiaName: "Pinheiro De Ázere",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Joaninho",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São João De Areias",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "União Das Freguesias De Ovoa E Vimieiro",
            freguesiaCode: "10",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Comba Dão E Couto Do Mosteiro",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Treixedo E Nagozela",
            freguesiaCode: "12",
          },
        ],
      },
      {
        countyName: "São João Da Pesqueira",
        countyCode: "15",
        fregusias: [
          {
            freguesiaName: "Castanheiro Do Sul",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ervedosa Do Douro",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Nagozelo Do Douro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Paredes Da Beira",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Riodades",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Soutelo Do Douro",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Vale De Figueira",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Valongo Dos Azeites",
            freguesiaCode: "12",
          },
          {
            freguesiaName:
              "União Das Freguesias De São João Da Pesqueira E Várzea De Trevões",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "União Das Freguesias De Trevões E Espinhosa",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "União Das Freguesias De Vilarouco E Pereiros",
            freguesiaCode: "17",
          },
        ],
      },
      {
        countyName: "São Pedro Do Sul",
        countyCode: "16",
        fregusias: [
          {
            freguesiaName: "Bordonhos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Figueiredo De Alva",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Manhouce",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Pindelo Dos Milagres",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pinho",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Félix",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Serrazes",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Sul",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Valadares",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Vila Maior",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Carvalhais E Candal",
            freguesiaCode: "20",
          },
          {
            freguesiaName:
              "União Das Freguesias De Santa Cruz Da Trapa E São Cristóvão De Lafões",
            freguesiaCode: "21",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Martinho Das Moitas E Covas Do Rio",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Pedro Do Sul, Várzea E Baiões",
            freguesiaCode: "23",
          },
        ],
      },
      {
        countyName: "Sátão",
        countyCode: "17",
        fregusias: [
          {
            freguesiaName: "Avelal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ferreira De Aves",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Mioma",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Rio De Moinhos",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "São Miguel De Vila Boa",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Sátão",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Silvã De Cima",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "União Das Freguesias De Águas Boas E Forles",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Romãs, Decermilo E Vila Longa",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Sernancelhe",
        countyCode: "18",
        fregusias: [
          {
            freguesiaName: "Arnas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Carregal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Chosendo",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Cunha",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Faia",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Granjal",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Lamosa",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Quintela",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Vila Da Ponte",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Ferreirim E Macieira",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Fonte Arcada E Escurquela",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "União Das Freguesias De Penso E Freixinho",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Sernancelhe E Sarzeda",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Tabuaço",
        countyCode: "19",
        fregusias: [
          {
            freguesiaName: "Adorigo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Arcos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Chavães",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Desejosa",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Granja Do Tedo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Longa",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Sendim",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Tabuaço",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Valença Do Douro",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "União Das Freguesias De Barcos E Santa Leocádia",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "União Das Freguesias De Paradela E Granjinha",
            freguesiaCode: "19",
          },
          {
            freguesiaName:
              "União Das Freguesias De Pinheiros E Vale De Figueira",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "União Das Freguesias De Távora E Pereiro",
            freguesiaCode: "21",
          },
        ],
      },
      {
        countyName: "Tarouca",
        countyCode: "20",
        fregusias: [
          {
            freguesiaName: "Mondim Da Beira",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Salzedas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São João De Tarouca",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Várzea Da Serra",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "União Das Freguesias De Gouviães E Ucanha",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Granja Nova E Vila Chã Da Beira",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "União Das Freguesias De Tarouca E Dálvares",
            freguesiaCode: "13",
          },
        ],
      },
      {
        countyName: "Tondela",
        countyCode: "21",
        fregusias: [
          {
            freguesiaName: "Campo De Besteiros",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Canas De Santa Maria",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Castelões",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Dardavaz",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ferreirós Do Dão",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Guardão",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Lajeosa Do Dão",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Lobão Da Beira",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Molelos",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Parada De Gonta",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Santiago De Besteiros",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Tonda",
            freguesiaCode: "22",
          },
          {
            freguesiaName:
              "União Das Freguesias De Barreiro De Besteiros E Tourigo",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "União Das Freguesias De Caparrosa E Silvares",
            freguesiaCode: "28",
          },
          {
            freguesiaName:
              "União Das Freguesias De Mouraz E Vila Nova Da Rainha",
            freguesiaCode: "29",
          },
          {
            freguesiaName:
              "União Das Freguesias De São João Do Monte E Mosteirinho",
            freguesiaCode: "30",
          },
          {
            freguesiaName:
              "União Das Freguesias De São Miguel Do Outeiro E Sabugosa",
            freguesiaCode: "31",
          },
          {
            freguesiaName: "União Das Freguesias De Tondela E Nandufe",
            freguesiaCode: "32",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vilar De Besteiros E Mosteiro De Fráguas",
            freguesiaCode: "33",
          },
        ],
      },
      {
        countyName: "Vila Nova De Paiva",
        countyCode: "22",
        fregusias: [
          {
            freguesiaName: "Pendilhe",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Queiriga",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Touro",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Vila Cova À Coelheira",
            freguesiaCode: "06",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vila Nova De Paiva, Alhais E Fráguas",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Viseu",
        countyCode: "23",
        fregusias: [
          {
            freguesiaName: "Abraveses",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Bodiosa",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Calde",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Campo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Cavernães",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Cota",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Fragosela",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Lordosa",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Silgueiros",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Mundão",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Orgens",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Povolide",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "Ranhados",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Ribafeita",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Rio De Loba",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Santos Evos",
            freguesiaCode: "25",
          },
          {
            freguesiaName: "São João De Lourosa",
            freguesiaCode: "27",
          },
          {
            freguesiaName: "São Pedro De France",
            freguesiaCode: "29",
          },
          {
            freguesiaName: "União Das Freguesias De Barreiros E Cepões",
            freguesiaCode: "35",
          },
          {
            freguesiaName:
              "União Das Freguesias De Boa Aldeia, Farminhão E Torredeita",
            freguesiaCode: "36",
          },
          {
            freguesiaName: "Coutos De Viseu",
            freguesiaCode: "37",
          },
          {
            freguesiaName: "União Das Freguesias De Faíl E Vila Chã De Sá",
            freguesiaCode: "38",
          },
          {
            freguesiaName: "Repeses E São Salvador",
            freguesiaCode: "39",
          },
          {
            freguesiaName: "São Cipriano E Vil De Souto",
            freguesiaCode: "40",
          },
          {
            freguesiaName: "Viseu",
            freguesiaCode: "41",
          },
        ],
      },
      {
        countyName: "Vouzela",
        countyCode: "24",
        fregusias: [
          {
            freguesiaName: "Alcofra",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Campia",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Fornelo Do Monte",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Queirã",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Miguel Do Mato",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ventosa",
            freguesiaCode: "11",
          },
          {
            freguesiaName:
              "União Das Freguesias De Cambra E Carvalhal De Vermilhas",
            freguesiaCode: "13",
          },
          {
            freguesiaName:
              "União Das Freguesias De Fataunços E Figueiredo Das Donas",
            freguesiaCode: "14",
          },
          {
            freguesiaName:
              "União Das Freguesias De Vouzela E Paços De Vilharigues",
            freguesiaCode: "15",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Da Madeira (Madeira)",
    code: 31,
    county: [
      {
        countyName: "Calheta",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Arco Da Calheta",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Calheta",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Estreito Da Calheta",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Fajã Da Ovelha",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Jardim Do Mar",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Paúl Do Mar",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Ponta Do Pargo",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Prazeres",
            freguesiaCode: "08",
          },
        ],
      },
      {
        countyName: "Câmara De Lobos",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Câmara De Lobos",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Curral Das Freiras",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Estreito De Câmara De Lobos",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Quinta Grande",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Jardim Da Serra",
            freguesiaCode: "05",
          },
        ],
      },
      {
        countyName: "Funchal",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Imaculado Coração De Maria",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Monte",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Funchal (Santa Luzia)",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Funchal (Santa Maria Maior)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santo António",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São Gonçalo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "São Martinho",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Funchal (São Pedro)",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "São Roque",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Funchal (Sé)",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Machico",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Água De Pena",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Caniçal",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Machico",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Porto Da Cruz",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santo António Da Serra",
            freguesiaCode: "05",
          },
        ],
      },
      {
        countyName: "Ponta Do Sol",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Canhas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Madalena Do Mar",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ponta Do Sol",
            freguesiaCode: "03",
          },
        ],
      },
      {
        countyName: "Porto Moniz",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Achadas Da Cruz",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Porto Moniz",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ribeira Da Janela",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Seixal",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Ribeira Brava",
        countyCode: "07",
        fregusias: [
          {
            freguesiaName: "Campanário",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ribeira Brava",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Serra De Água",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Tabua",
            freguesiaCode: "04",
          },
        ],
      },
      {
        countyName: "Santa Cruz",
        countyCode: "08",
        fregusias: [
          {
            freguesiaName: "Camacha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Caniço",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Gaula",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Santa Cruz",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Santo António Da Serra",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Santana",
        countyCode: "09",
        fregusias: [
          {
            freguesiaName: "Arco De São Jorge",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Faial",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santana",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Jorge",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Roque Do Faial",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ilha",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "São Vicente",
        countyCode: "10",
        fregusias: [
          {
            freguesiaName: "Boa Ventura",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ponta Delgada",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Vicente",
            freguesiaCode: "03",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha De Porto Santo (Madeira)",
    code: 32,
    county: [
      {
        countyName: "Porto Santo",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Porto Santo",
            freguesiaCode: "01",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha De Santa Maria (Açores)",
    code: 41,
    county: [
      {
        countyName: "Vila Do Porto",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Almagreira",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santa Bárbara",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo Espírito",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "São Pedro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vila Do Porto",
            freguesiaCode: "05",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha De São Miguel (Açores)",
    code: 42,
    county: [
      {
        countyName: "Lagoa",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Água De Pau",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cabouco",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Lagoa (Nossa Senhora Do Rosário)",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Lagoa (Santa Cruz)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ribeira Chã",
            freguesiaCode: "05",
          },
        ],
      },
      {
        countyName: "Nordeste",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Achada",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Achadinha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Lomba Da Fazenda",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Nordeste",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Salga",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Santana",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Algarvia",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Santo António De Nordestinho",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "São Pedro De Nordestinho",
            freguesiaCode: "10",
          },
        ],
      },
      {
        countyName: "Ponta Delgada",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Arrifes",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Candelária",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Capelas",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Covoada",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Fajã De Baixo",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Fajã De Cima",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Fenais Da Luz",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Feteiras",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Ginetes",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Mosteiros",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ponta Delgada (São Sebastião)",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Ponta Delgada (São José)",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "Ponta Delgada (São Pedro)",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "Relva",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "Remédios",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Rosto Do Cão (Livramento)",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Rosto Do Cão (São Roque)",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Santa Bárbara",
            freguesiaCode: "19",
          },
          {
            freguesiaName: "Santo António",
            freguesiaCode: "20",
          },
          {
            freguesiaName: "São Vicente Ferreira",
            freguesiaCode: "21",
          },
          {
            freguesiaName: "Sete Cidades",
            freguesiaCode: "22",
          },
          {
            freguesiaName: "Ajuda Da Bretanha",
            freguesiaCode: "23",
          },
          {
            freguesiaName: "Pilar Da Bretanha",
            freguesiaCode: "24",
          },
          {
            freguesiaName: "Santa Clara",
            freguesiaCode: "25",
          },
        ],
      },
      {
        countyName: "Povoação",
        countyCode: "04",
        fregusias: [
          {
            freguesiaName: "Água Retorta",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Faial Da Terra",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Furnas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Nossa Senhora Dos Remédios",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Povoação",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ribeira Quente",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Ribeira Grande",
        countyCode: "05",
        fregusias: [
          {
            freguesiaName: "Calhetas",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Fenais Da Ajuda",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Lomba Da Maia",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Lomba De São Pedro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Maia",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Pico Da Pedra",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Porto Formoso",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Rabo De Peixe",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Ribeira Grande (Conceição)",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Ribeira Grande (Matriz)",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Ribeira Seca",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ribeirinha",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Santa Bárbara",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Brás",
            freguesiaCode: "14",
          },
        ],
      },
      {
        countyName: "Vila Franca Do Campo",
        countyCode: "06",
        fregusias: [
          {
            freguesiaName: "Água De Alto",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Ponta Garça",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ribeira Das Taínhas",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Vila Franca Do Campo (São Miguel)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Vila Franca Do Campo (São Pedro)",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Ribeira Seca",
            freguesiaCode: "06",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Terceira (Açores)",
    code: 43,
    county: [
      {
        countyName: "Angra Do Heroísmo",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Altares",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Angra (Nossa Senhora Da Conceição)",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Angra (Santa Luzia)",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Angra (São Pedro)",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Angra (Sé)",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Cinco Ribeiras",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Doze Ribeiras",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Feteira",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Porto Judeu",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Posto Santo",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Raminho",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ribeirinha",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Santa Bárbara",
            freguesiaCode: "13",
          },
          {
            freguesiaName: "São Bartolomeu De Regatos",
            freguesiaCode: "14",
          },
          {
            freguesiaName: "São Bento",
            freguesiaCode: "15",
          },
          {
            freguesiaName: "São Mateus Da Calheta",
            freguesiaCode: "16",
          },
          {
            freguesiaName: "Serreta",
            freguesiaCode: "17",
          },
          {
            freguesiaName: "Terra Chã",
            freguesiaCode: "18",
          },
          {
            freguesiaName: "Vila De São Sebastião",
            freguesiaCode: "19",
          },
        ],
      },
      {
        countyName: "Praia Da Vitória",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Agualva",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Biscoitos",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cabo Da Praia",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Fonte Do Bastardo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Fontinhas",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Lajes",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Praia Da Vitória (Santa Cruz)",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Quatro Ribeiras",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "São Brás",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Vila Nova",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Porto Martins",
            freguesiaCode: "11",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Da Graciosa (Açores)",
    code: 44,
    county: [
      {
        countyName: "Santa Cruz Da Graciosa",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Guadalupe",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Luz",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "São Mateus",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santa Cruz Da Graciosa",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha De São Jorge (Açores)",
    code: 45,
    county: [
      {
        countyName: "Calheta De São Jorge",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Calheta",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Norte Pequeno",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ribeira Seca",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santo Antão",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Topo (Nossa Senhora Do Rosário)",
            freguesiaCode: "05",
          },
        ],
      },
      {
        countyName: "Velas",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Manadas (Santa Bárbara)",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Norte Grande (Neves)",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Rosais",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santo Amaro",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Urzelina (São Mateus)",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Velas (São Jorge)",
            freguesiaCode: "06",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Do Pico (Açores)",
    code: 46,
    county: [
      {
        countyName: "Lajes Do Pico",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Calheta De Nesquim",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Lajes Do Pico",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Piedade",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Ribeiras",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Ribeirinha",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São João",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "Madalena",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Bandeiras",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Candelária",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Criação Velha",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Madalena",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Caetano",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "São Mateus",
            freguesiaCode: "06",
          },
        ],
      },
      {
        countyName: "São Roque Do Pico",
        countyCode: "03",
        fregusias: [
          {
            freguesiaName: "Prainha",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Santa Luzia",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Santo Amaro",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santo António",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "São Roque Do Pico",
            freguesiaCode: "05",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Do Faial (Açores)",
    code: 47,
    county: [
      {
        countyName: "Horta",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Capelo",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Castelo Branco",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Cedros",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Feteira",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Flamengos",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Horta (Angústias)",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Horta (Conceição)",
            freguesiaCode: "07",
          },
          {
            freguesiaName: "Horta (Matriz)",
            freguesiaCode: "08",
          },
          {
            freguesiaName: "Pedro Miguel",
            freguesiaCode: "09",
          },
          {
            freguesiaName: "Praia Do Almoxarife",
            freguesiaCode: "10",
          },
          {
            freguesiaName: "Praia Do Norte",
            freguesiaCode: "11",
          },
          {
            freguesiaName: "Ribeirinha",
            freguesiaCode: "12",
          },
          {
            freguesiaName: "Salão",
            freguesiaCode: "13",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Das Flores (Açores)",
    code: 48,
    county: [
      {
        countyName: "Lajes Das Flores",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Fajã Grande",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Fajãzinha",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Fazenda",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Lajedo",
            freguesiaCode: "04",
          },
          {
            freguesiaName: "Lajes Das Flores",
            freguesiaCode: "05",
          },
          {
            freguesiaName: "Lomba",
            freguesiaCode: "06",
          },
          {
            freguesiaName: "Mosteiro",
            freguesiaCode: "07",
          },
        ],
      },
      {
        countyName: "Santa Cruz Das Flores",
        countyCode: "02",
        fregusias: [
          {
            freguesiaName: "Caveira",
            freguesiaCode: "01",
          },
          {
            freguesiaName: "Cedros",
            freguesiaCode: "02",
          },
          {
            freguesiaName: "Ponta Delgada",
            freguesiaCode: "03",
          },
          {
            freguesiaName: "Santa Cruz Das Flores",
            freguesiaCode: "04",
          },
        ],
      },
    ],
  },
  {
    district: "Ilha Corvo (Açores)",
    code: 49,
    county: [
      {
        countyName: "Corvo",
        countyCode: "01",
        fregusias: [
          {
            freguesiaName: "Corvo",
            freguesiaCode: "01",
          },
        ],
      },
    ],
  },
];

export { AddressData };
